{
  "action": {
    "accept": "Accept",
    "acceptPageAccessRisk": "I understand and accept",
    "acceptRedundancy": "Confirm redundant",
    "activate": "Activate",
    "add": "Add",
    "addExistingDocument": "Add existing document",
    "addField": "Add field",
    "addFieldMapping": "Add mapping",
    "addHint": "Press enter to add",
    "addIntegration": "Add integration",
    "addMember": "Add member",
    "addNestedField": "Nested field",
    "addToCalendar": "Add to calendar",
    "allDocuments": "All documents",
    "analyzeChat": "Analyze conversation",
    "apply": "Apply",
    "ask": "Ask",
    "attachFile": "Attach a file",
    "back": "Back",
    "backToAgent": "Back to agent",
    "backToDocuments": "Back to documents",
    "backToHome": "Back to home",
    "backToSignIn": "Back to sign in",
    "ban": "Ban user",
    "blockChat": "Block conversation",
    "cancel": "Cancel",
    "cancelInvitation": "Cancel invitation",
    "change": "Change",
    "changeAgent": "Change agent",
    "changeRole": "Change role",
    "check": "Check",
    "clear": "Clear",
    "clearSearch": "Clear search",
    "close": "Close",
    "closeChat": "Close the chat",
    "closeSidebar": "Close sidebar",
    "collapse": "Collapse",
    "compare": "Compare",
    "connect": "Connect",
    "continue": "Continue",
    "copied": "Copied",
    "copy": "Copy",
    "copyLink": "Copy link",
    "crawl": "Crawl",
    "create": "Create",
    "createAgent": "Create agent",
    "createApiKey": "Create API key",
    "createDocument": "Create document",
    "createFolder": "Create folder",
    "createNew": "Create new",
    "createNewChat": "Start a new chat",
    "createNotification": "Create notification",
    "createRevise": "Revise answer",
    "createSubfolder": "Create subfolder",
    "deactivate": "Deactivate",
    "decline": "Decline",
    "delete": "Delete",
    "deleteAllMemories": "Delete all memories",
    "deleteAllNotifications": "Delete all notifications",
    "deleteFolder": "Delete folder",
    "deleteMyConversations": "Delete my conversations",
    "deleteProfile": "Delete profile",
    "deleteRow": "Delete row",
    "deselectHint": "Press enter to remove",
    "disableAutoRefresh": "Disable automatic update",
    "disablePageAccess": "Turn off page access",
    "disconnect": "Disconnect",
    "embeddingBackToPlatform": "Back to the platform",
    "embeddingRemove": "Remove",
    "embeddingUseEndpoint": "Use the endpoint",
    "enablePageAccess": "Turn page access back on",
    "modelEndpointConnect": "Connect your endpoint",
    "dismissRedundancy": "Restore to search",
    "documentRefreshNow": "Update now",
    "documentSetRefresh": "Set update",
    "documentSourceSettings": "Sync settings",
    "documentSourceSyncNow": "Sync now",
    "documentSourceUnlink": "Unlink",
    "download": "Download",
    "downloadIcs": "Download .ics",
    "downloadTeamsApp": "Download Teams app (.zip)",
    "downvote": "Not helpful",
    "dropFile": "Drop file here",
    "dropFilesToImport": "Drop files to import the documents",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "editAgent": "Edit agent",
    "editDocument": "Edit document",
    "editRevise": "Update revised answer",
    "editSchema": "Edit schema",
    "enableAutoRefresh": "Enable automatic update",
    "expand": "Expand",
    "export": "Export",
    "exportMyData": "Export my data",
    "feedback": "I want to make a report",
    "focusMessage": "Go to the message field",
    "foldSidebar": "Close sidebar",
    "forgetPassword": "Forgot your password?",
    "generate": "Generate",
    "generateFromJson": "Generate from JSON",
    "getDirections": "Directions",
    "getMoreInfo": "More information",
    "goBack": "Go back",
    "hangUp": "End the call",
    "impersonate": "Impersonate",
    "import": "Import ({count})",
    "importFromCrawler": "Import from crawler",
    "integrationCheck": "Check connection",
    "integrationConnectMicrosoft": "Connect with Microsoft",
    "integrationConnectApp": "Connect the app",
    "integrationUseOwnApp": "Use an app of your own tenant",
    "integrationAdvancedSetup": "Advanced setup",
    "integrationDisconnect": "Disconnect",
    "integrationReconnect": "Reconnect",
    "integrationRotateSecret": "Replace the client secret",
    "invite": "Invite",
    "inviteMember": "Invite member",
    "leave": "Leave",
    "link": "Link",
    "linkExisting": "Link existing",
    "linkFromProvider": "Link from {provider}",
    "loadDefaults": "Load defaults",
    "manageAgentAccess": "Manage agent access",
    "manageAgentMemberAccess": "Manage access",
    "manageProfile": "Manage your profile",
    "markAllAsRead": "Mark all as read",
    "markAsRead": "Mark as read",
    "moreActions": "Actions",
    "moveDown": "Move down",
    "moveHere": "Move here",
    "moveToFolder": "Move to folder",
    "moveUp": "Move up",
    "mute": "Mute the microphone",
    "next": "Next",
    "open": "Open",
    "openChat": "Open the chat",
    "openFilters": "Open the filters",
    "openInGmail": "Open in Gmail",
    "openInMailApp": "Open in mail app",
    "openInOutlook": "Open in Outlook",
    "openInSms": "Open in SMS",
    "openInTelegram": "Open in Telegram",
    "openInWhatsApp": "Open in WhatsApp",
    "openInYahooMail": "Open in Yahoo Mail",
    "openSettings": "Open settings",
    "openSidebar": "Open sidebar",
    "pan": "Pan",
    "pause": "Pause",
    "pin": "Pin the panel",
    "playVoicePreview": "Play a sample of this voice",
    "prev": "Previous",
    "previewAsPage": "Preview as chat page",
    "previewAsWidget": "Preview as widget",
    "previous": "Previous",
    "proceed": "Proceed",
    "profileMenu": "Profile, theme and language",
    "recoverPassword": "Recover password",
    "refill": "Refill",
    "refillHistory": "Refill history",
    "refresh": "Refresh",
    "refreshPrices": "Refresh prices",
    "reviewPageAccessRisk": "Review and accept the risk",
    "setPrice": "Set the price",
    "regenerate": "Regenerate",
    "remove": "Remove",
    "removeFromQueue": "Remove from the queue",
    "queueMessage": "Send when the answer ends",
    "removeField": "Remove field",
    "renameChat": "Rename",
    "renameFolder": "Rename folder",
    "reorder": "Reorder",
    "reprocess": "Reprocess",
    "resendInvitation": "Resend invitation",
    "reset": "Reset",
    "resetPassword": "Reset password",
    "resize": "Resize",
    "resume": "Resume",
    "resumeInPlayground": "Resume in Try",
    "retry": "Retry",
    "retryNow": "Try again now",
    "revoke": "Revoke",
    "revokeAllOtherSessions": "Sign out all",
    "revokeAllSessions": "Revoke all sessions",
    "run": "Run",
    "save": "Save",
    "scrollToBottom": "Back to bottom",
    "searchAllFolders": "Search in all folders",
    "select": "Select",
    "selectHint": "Press enter to select",
    "selected": "Selected",
    "send": "Send",
    "sendLink": "Send link",
    "share": "Share",
    "shareDocumentWithAgents": "Share with other agents",
    "showLess": "Show less",
    "showMore": "View more {count}",
    "showShortcuts": "Show keyboard shortcuts",
    "signIn": "Sign in",
    "signInWithSocialProvider": "Sign in with {provider}",
    "signOut": "Sign out",
    "signUp": "Sign up",
    "signUpWithSocialProvider": "Sign up with {provider}",
    "startNewChat": "Start a new chat",
    "stop": "Stop",
    "stopImpersonation": "Stop impersonation",
    "stopVoicePreview": "Stop the sample",
    "submit": "Submit",
    "switch": "Switch",
    "takePhoto": "Take a photo",
    "talk": "Talk",
    "testIntegration": "Test connection",
    "toggleIntegration": "Enable/Disable",
    "toggleSidebar": "Open or close the sidebar",
    "toggleTheme": "Change theme",
    "unban": "Unban user",
    "unblockChat": "Unblock conversation",
    "unfoldSidebar": "Open sidebar",
    "unlinkDocument": "Unlink from agent",
    "unmute": "Unmute the microphone",
    "unpin": "Unpin the panel",
    "update": "Update",
    "upvote": "Helpful",
    "useColorsForAgentHeader": "Use color for header",
    "view": "View",
    "viewAgentTree": "View tree",
    "viewAll": "View all",
    "viewChat": "View the chat",
    "viewDetails": "View details",
    "viewDocument": "View the document",
    "viewDocuments": "View the documents",
    "viewProfile": "View profile",
    "viewRecentChats": "View recent chats",
    "welcomePopup": "Show welcome popup",
    "zoomIn": "Zoom In",
    "zoomOut": "Zoom out",
    "createWebSource": "Create source",
    "webSourceConfirmRemoval": "Remove the {count} pages"
  },
  "agent": {
    "channel": {
      "app": "App",
      "frontoffice": "Platform",
      "widget": "Widget"
    },
    "reasoning": {
      "high": "High",
      "low": "Low",
      "medium": "Medium",
      "off": "Off"
    },
    "reasoningSummary": {
      "auto": "Auto",
      "concise": "Concise",
      "detailed": "Detailed"
    },
    "searchMode": {
      "balanced": "Balanced (vector + keywords)",
      "keyword": "Keyword (full-text only)",
      "semantic": "Semantic (vector only)"
    },
    "status": {
      "active": "Active",
      "draft": "Draft",
      "inactive": "Inactive"
    },
    "tool": {
      "createSpreadsheet": "Create new Excel files",
      "createWordDocument": "Create new Word documents",
      "fetchTeamsChannelHistory": "Teams channel history",
      "geocode": "Geocoding",
      "getWeather": "Weather data",
      "querySpreadsheet": "Spreadsheet queries",
      "readDocumentFile": "Read document files",
      "requestGeolocation": "Geolocation",
      "retrieveRevisedAnswers": "Verified answers",
      "runWorker": "Parallel workers",
      "scheduleWakeup": "Repeated checks",
      "searchInKnowledgeBase": "Knowledge base",
      "searchInUserFiles": "User files",
      "shareDocument": "Document download links",
      "showArtifact": "Artifacts",
      "showCalendarEvent": "Calendar event",
      "showComparison": "Comparison",
      "showContactForm": "Contact form",
      "showDiagram": "Diagram or chart",
      "showEmail": "Email",
      "showForm": "Multi-step Form",
      "showImageGallery": "Image gallery",
      "showLocation": "Interactive map",
      "showMessage": "Messaging",
      "showMultipleChoice": "Multiple choice",
      "showProductList": "Product catalog",
      "showQrCode": "QR code",
      "showSources": "Sources & references",
      "showSuggestedReply": "Suggested replies",
      "showVideo": "Video",
      "showWeather": "Weather widget",
      "showWebPages": "Web page links",
      "spreadsheet": "Spreadsheets",
      "useAllUserFiles": "Use all user files",
      "useAllUserKb": "Use the entire user KB",
      "userMemory": "User memory",
      "wordDocument": "Word documents"
    },
    "toolWorkingSetMode": {
      "active": "Active",
      "off": "Off",
      "shadow": "Shadow (record only)"
    },
    "visibility": {
      "organization": "Organization",
      "private": "Signed-in users",
      "public": "Public",
      "restricted": "Private"
    },
    "visibilityHint": {
      "organization": "Every member of the organization, except those limited to other agents.",
      "private": "Anyone with an account: anyone can sign up.",
      "public": "Anyone, even without signing in.",
      "restricted": "Owners, admins and the members enabled for it."
    }
  },
  "agentMemberAccess": {
    "manager": "Owner or admin",
    "notLimited": "All agents",
    "hintOrganization": "Every member who is not limited uses it. Enable the limited members here; to limit a person, open the Members page.",
    "hintRestricted": "Only owners, admins and the members you enable here use it. Enabled members see their own chats, not the others'.",
    "readError": "The members could not be read: close the dialog and try again.",
    "restrictTitle": "Make the agent Private?",
    "restrictMembers": "{n} member loses access to the agent. | {n} members lose access to the agent.",
    "restrictOutsiders": "People outside the organization will no longer be able to use it.",
    "restrictUnknown": "Whoever is not enabled loses access to the agent.",
    "restrictDescription": "A Private agent is used only by owners, admins and the enabled members, whom you can choose from Manage access, after saving too."
  },
  "agentApiToolStatus": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "agentType": {
    "chat": "Chat",
    "reasoning": "Reasoning"
  },
  "assistantTool": {
    "navigate": "Open a page",
    "run": "Act on the screen",
    "screen": "Read the screen"
  },
  "auth": {
    "genericError": "An error occurred. Try again.",
    "haveAccount": "Already have an account?",
    "noAccount": "Don't have an account?",
    "popupBlocked": "Pop-up blocked. Allow pop-ups for this site and try again.",
    "resetSent": "If an account exists with this email, you will receive a password reset link.",
    "resetSentTitle": "Check your email",
    "resetTitle": "Reset your password",
    "resetUnavailable": "You can't reset your password in this chat: do it where you created your account.",
    "signInTitle": "Sign in to your account",
    "signUpSuccessTitle": "Account created!",
    "signUpTitle": "Create your account",
    "verifyEmail": "We've sent a verification email to your address. Check your inbox."
  },
  "branding": {
    "asset": {
      "emailBanner": "Email banner",
      "emailLogo": "Email logo",
      "logoDark": "Logo on a dark background",
      "logoLight": "Logo on a light background",
      "mark": "Mark"
    },
    "assetHint": {
      "emailBanner": "Under the email logo, up to {width} px wide.",
      "emailLogo": "At the top of every email.",
      "logoDark": "Dark theme. Without it, the light logo.",
      "logoLight": "Sidebar and header.",
      "mark": "Square: sign-in card, folded sidebar and app icons."
    },
    "bundledImage": "Default image",
    "color": {
      "accent": "Accent",
      "brand": "Brand",
      "info": "Info"
    },
    "colors": "Colors",
    "colorsHint": "The light and the dark theme each have their own palette: a dark theme usually wants a lighter brand. Text on these colors stays readable whatever you pick.",
    "darkLogo": "The dark logo",
    "images": "Images",
    "imagesHint": "SVG, PNG or WebP, up to {maxSize} KB and {maxSide} pixels per side. Each preview shows the image on both themes: check that it reads on the dark one too. The email images are converted to PNG, or to JPEG when they have no transparency, since many mail clients show neither SVG nor WebP.",
    "lightLogo": "The light logo",
    "loadFailed": "The theme of this deployment could not be read.",
    "markBesideName": "The mark beside the name",
    "mode": "Light and dark",
    "modeDark": "Always dark",
    "modeHint": "A fixed theme hides the users' switch.",
    "modeLight": "Always light",
    "modeSystem": "User's choice",
    "neutralMark": "The initial of the name",
    "noImage": "No image",
    "notRuntimeContent": "The theme can only be viewed here: this frontend is built without VITE_RUNTIME_BRANDING and keeps its compile-time look, while a saved theme would still reach the emails and the chat widget of every organization.",
    "notRuntimeTitle": "This build does not read the theme",
    "palette": {
      "dark": "Dark theme",
      "light": "Light theme"
    },
    "removeImage": "Remove the image",
    "replaceImage": "Replace",
    "saveAndReload": "Save and reload",
    "saveFailed": "Theme not saved",
    "saveFailedHint": "The theme could not be saved. Try again in a moment.",
    "savedMeanwhile": "Someone else saved the theme",
    "savedMeanwhileHint": "The theme changed after this page opened, and saving would undo those changes. Reload the page to see them, then make yours again.",
    "text": {
      "companyName": "Company name",
      "description": "Description",
      "productName": "Product name",
      "productTagline": "Tagline",
      "shortName": "Short name"
    },
    "textHint": {
      "companyName": "Email footer. Empty: no footer.",
      "description": "One sentence about the product: the description of the installed app.",
      "productName": "Browser tab, installed app, emails and Teams app. Once you change it, an image you do not upload is no longer Eight Wave's: the initial of the name, or none in the emails.",
      "productTagline": "Above the short name. Empty: none.",
      "shortName": "The strong line of the logo, and the name under the icon of the installed app."
    },
    "texts": "Names",
    "unsupportedType": "Use an SVG, PNG or WebP image.",
    "uploadFailed": "Image not saved",
    "uploadFailedHint": "The image could not be uploaded. Try again, or check its format and size.",
    "uploadImage": "Upload",
    "useBundledImage": "Use the default image"
  },
  "browserEngine": {
    "fetch": "Fetch · static HTML",
    "puppeteer": "Puppeteer · local browser",
    "remote": "Remote · remote browser"
  },
  "channelDescription": {
    "teams": "Publish this agent as a bot inside Microsoft Teams.",
    "whatsapp": "Let users chat with this agent on WhatsApp via the Meta Cloud API."
  },
  "channelGuide": {
    "docs": "Open the official documentation",
    "intro": "Follow the steps in order. Open each linked service in a new browser tab and copy the values into the form. Don't close this window until you've finished.",
    "teams": {
      "step1": "Sign in to the Microsoft Azure portal with your work or school account.",
      "step2": "Create a new «Azure Bot» resource and give it a name. When asked, choose its app type, «Single tenant» or «Multi-tenant»: remember your choice for step 5.",
      "step3": "Open the bot you just created → «Configuration», copy the «Microsoft App ID» and paste it into the App ID field.",
      "step4": "Next to the Microsoft App ID, click «Manage password»: this opens the app's registration in Microsoft Entra ID (a different page from the bot). There, under «Certificates & secrets», create a new client secret and copy its «Value» (not the Secret ID) into the App password field. Copy it right away: it's shown only once.",
      "step5": "In the App type field choose the same value as in step 2. For «Single tenant», copy the «Directory (tenant) ID» from the app registration «Overview» page into the Tenant ID field.",
      "step6": "Save the form: the Webhook URL appears at the top of this guide.",
      "step7": "Back in the bot → «Configuration», set the «Messaging endpoint» to the Webhook URL and save.",
      "step8": "Open the bot → «Channels» and add the «Microsoft Teams» channel.",
      "step9": "Use the card menu (⋯ → Download Teams app) to get the package and upload it in Teams from «Apps → Manage your apps → Upload an app»."
    },
    "title": "Setup guide",
    "webhookUrlAfterSave": "It appears here once you save.",
    "whatsapp": {
      "step1": "Open the Meta for Developers portal and sign in with your Facebook account (create one if you don't have it yet).",
      "step2": "Create a new app: choose the «Business» type, give it a name, then add the «WhatsApp» product to it.",
      "step3": "Open WhatsApp → «API Setup». Copy the «Phone number ID» (a long number, not the phone number itself) and paste it into the Phone number ID field.",
      "step4": "Still in «API Setup», generate an access token. For a connection that doesn't expire, create a «System User» token with the whatsapp_business_messaging permission, then paste it into the Access token field.",
      "step5": "Open App settings → «Basic», click «Show» next to «App secret», copy it and paste it into the App secret field. This lets us verify that incoming messages really come from Meta.",
      "step6": "We've already filled the «Verify token» field with a ready-to-use value (use «Regenerate» for a new one). You'll paste this exact value into Meta in step 8.",
      "step7": "Save the form: the Webhook URL appears at the top of this guide.",
      "step8": "Go back to WhatsApp → «Configuration» and edit the webhook: paste the Webhook URL and the same Verify token, save, then subscribe to the «messages» event.",
      "step9": "Send a message to your WhatsApp number to check that the agent replies."
    }
  },
  "chartLabel": {
    "2g": "2G",
    "3g": "3G",
    "4g": "4G",
    "Africa": "Africa",
    "America": "America",
    "Asia": "Asia",
    "Australia": "Australia",
    "Europe": "Europe",
    "Pacific": "Pacific",
    "abusive": "Abusive",
    "aggressive": "Aggressive",
    "api": "API",
    "critical": "Critical",
    "dark": "Dark",
    "data_leak": "Data leak",
    "degrading": "Degrading",
    "desktop": "Desktop",
    "direct": "Direct",
    "disengaged": "Disengaged",
    "empty_reply": "Empty reply",
    "endpoint": "Endpoint",
    "excited": "Excited",
    "failed_action": "Failed action",
    "false_success": "False success",
    "frustrated": "Frustrated",
    "goal_met": "Goal met",
    "goal_not_met": "Goal not met",
    "group": "Group",
    "hallucination": "Hallucination",
    "high": "High",
    "impatient": "Impatient",
    "improving": "Improving",
    "inappropriate_tone": "Inappropriate tone",
    "light": "Light",
    "low": "Low",
    "medium": "Medium",
    "mobile": "Mobile",
    "negative": "Negative",
    "neutral": "Neutral",
    "off_brand": "Off-brand",
    "other": "Other",
    "polite": "Polite",
    "positive": "Positive",
    "reasoning": "Reasoning",
    "refusal_loop": "Refusal loop",
    "repetition": "Repetition",
    "slow-2g": "Slow 2G",
    "stable": "Stable",
    "stuck_flow": "Stuck flow",
    "tablet": "Tablet",
    "teams": "Teams",
    "unanalyzed": "Unanalyzed",
    "unclear": "Unclear",
    "unknown": "Unknown",
    "voice": "Voice",
    "web": "Web",
    "whatsapp": "WhatsApp"
  },
  "confirmDescription": {
    "documentRefreshTriggerOff": "Otherwise the next reading would overwrite what you wrote. You can turn it back on from the update card.",
    "embeddingBackToPlatform": "The knowledge base and the memories are embedded again with the platform model, from the text already stored: nothing is converted again. Until it is done the searches find only what is already back.",
    "embeddingBackToPlatformSameFamily": "Your endpoint computes the same model as the platform, so the vectors stay as they are and nothing is computed again: from now on the platform AI gateway computes them.",
    "embeddingRemove": "Without the platform AI gateway nothing else computes the vectors: the knowledge base, the corrected answers, the memories and the document processing stop until you activate an embedding model on your endpoint again. If the platform switches the gateway back on, they start again on its vectors by themselves.",
    "endpointOffWithEmbedding": "Besides its models, the knowledge base, the corrected answers, the memories and the document processing of every agent stop, until you switch it back on.",
    "integrationDisconnect": "They stay where they are with their documents, editable like any other, and stop updating. To sync them again you will have to connect the provider and link them once more.",
    "integrationRemove": "The stored credentials are deleted and the syncs towards this provider stop. To resume them you will have to configure it again.",
    "lastModelOff": "No other model of this organization is on: nothing can be picked for a new agent or as a default any more, and the agents on these models will answer with the default model.",
    "modelProviderDelete": "The saved models and their prices will be lost. Deletion is not possible while an agent uses one of its models, nor while the endpoint computes the embedding: move those agents to another model first, and remove the embedding in the Embedding section.",
    "modelRemove": "The agents using this model will stop answering until you move them to another model.",
    "revokeVoiceApiKey": "This key answers the voice channel of an agent: its voice stops working until the voice is turned off and on again in the agent settings."
  },
  "confirmTitle": {
    "deleteAgent": "Delete this agent?",
    "deleteAllMemories": "Delete every memory of this user?",
    "deleteBulkDocument": "Delete the selected documents?",
    "deleteDocument": "Delete this document?",
    "deleteFolder": "Delete this folder?",
    "deleteMyConversations": "Delete all your conversations?",
    "deleteSpreadsheet": "Delete this spreadsheet?",
    "deleteWordDocument": "Delete this Word document?",
    "documentRefreshTriggerOff": "Turn the automatic update off?",
    "embeddingBackToPlatform": "Compute the vectors on the platform again?",
    "embeddingBackToPlatformSameFamily": "Compute the vectors on the platform?",
    "embeddingRemove": "Remove the embedding from the endpoint?",
    "endpointOffWithEmbedding": "Switch off the endpoint that computes the vectors?",
    "excludeUserFile": "Remove this file from your files?",
    "integrationDisconnect": "Remove this connection?",
    "lastModelOff": "Switch off the last model?",
    "modelProviderDelete": "Delete the endpoint?",
    "modelRemove": "Remove {id}?",
    "unlinkAgent": "Remove this agent from the document?",
    "unlinkDocument": "Unlink this document from the agent?",
    "unlinkLastAgentDelete": "Remove the last agent from this document?",
    "unlinkSyncedFolder": "Unlink this folder?",
    "webSourceConfirmRemoval": "Remove {count} pages?",
    "unlinkWebSource": "Unlink the source?"
  },
  "conversationAnalysis": {
    "abuseCategory": {
      "data_extraction": "Data extraction",
      "harassment": "Harassment",
      "hate_speech": "Hate speech",
      "impersonation": "Impersonation",
      "off_topic_persistent": "Off-topic",
      "prompt_injection": "Prompt injection",
      "self_harm": "Self harm",
      "sexual_content": "Sexual content",
      "spam": "Spam",
      "violence": "Violence"
    },
    "confidence": {
      "high": "High",
      "low": "Low",
      "medium": "Medium"
    },
    "engagement": {
      "disengaged": "Disengaged",
      "high": "High",
      "low": "Low",
      "medium": "Medium"
    },
    "label": {
      "abuseDetected": "Abuse",
      "conversationSentiment": "Sentiment",
      "goalMet": "Goal met",
      "goalNotMet": "Goal not met",
      "llmIssueDetected": "LLM issue",
      "riskScore": "Risk score",
      "userEngagement": "Engagement",
      "userTone": "Tone"
    },
    "llmIssue": {
      "data_leak": "Data leak",
      "empty_reply": "Empty reply",
      "failed_action": "Failed action",
      "false_success": "False success",
      "hallucination": "Hallucination",
      "inappropriate_tone": "Inappropriate tone",
      "off_brand": "Off-brand",
      "refusal_loop": "Refusal loop",
      "repetition": "Repetition",
      "stuck_flow": "Stuck flow"
    },
    "sentiment": {
      "excited": "Excited",
      "frustrated": "Frustrated",
      "negative": "Negative",
      "neutral": "Neutral",
      "positive": "Positive"
    },
    "sentimentTrend": {
      "degrading": "Degrading",
      "improving": "Improving",
      "stable": "Stable"
    },
    "title": "Conversation analysis",
    "tone": {
      "abusive": "Abusive",
      "aggressive": "Aggressive",
      "impatient": "Impatient",
      "neutral": "Neutral",
      "polite": "Polite"
    },
    "trigger": {
      "agent_request": "On request",
      "manual": "Manual",
      "summary_cycle": "Automatic"
    }
  },
  "crawlMode": {
    "depth": "Depth crawling",
    "sitemap": "XML sitemap"
  },
  "dataProtection": {
    "downloadPdf": "Download PDF"
  },
  "diagram": {
    "classDiagram": "Class diagram",
    "erDiagram": "ER diagram",
    "flowchart": "Flowchart",
    "graph": "Graph",
    "sequenceDiagram": "Sequence diagram",
    "stateDiagram": "State diagram",
    "xychart": "XY chart"
  },
  "documentMetadata": {
    "affectedDocumentsStat": "Affected documents",
    "analyzedPages": "analyze {pages} on",
    "chunkSimilarTo": "{score}% similar to content in “{docName}”",
    "compare": "Compare",
    "compareChunks": "Semantic chunk comparison",
    "filterOnlyRedundantLabel": "Show only documents with unmanaged redundant chunks",
    "filterRedundant": "Show redundant",
    "hasRedundant": "This document contains redundant information with other files",
    "isRedundant": "Redundant",
    "openInProvider": "Open in {provider}",
    "originalChunk": "Original chunk (authoritative)",
    "pageCount": "no pages | {n} page | {n} pages",
    "readingTime": "{minutes} min",
    "redundancyAccepted": "Confirmed",
    "redundancyDismissed": "Restored",
    "redundancyExplainer": "These blocks repeat content the agent already finds in another document, or earlier in this one, and its search skips them. Confirm to leave them out, or restore them to put them back in search, in every agent.",
    "redundantChunk": "Redundant chunk (duplicate)",
    "redundantChunks": "no redundant chunks | {n} redundant chunk ({percent}%) | {n} redundant chunks ({percent}%)",
    "redundantChunksStat": "Redundant chunks",
    "redundantWarningMessage": "Some documents contain duplicate or redundant semantic chunks. They are automatically skipped during query retrieval to clean and optimize RAG context windows.",
    "redundantWarningServerMessage": "There are {chunks} unmanaged redundant semantic chunks distributed across {docs} documents for this agent (out of {totalChunks} chunks and {totalDocs} documents).",
    "redundantWarningTitle": "Duplicate or redundant content detected inside Knowledge Base",
    "redundantWith": "Redundant with chunk {chunkId} of {docName} ({score}% semantic similarity)",
    "showAll": "Show all",
    "thisDocument": "This document",
    "viewByChunks": "View by chunks",
    "viewDocument": "Document",
    "viewOriginal": "View original",
    "wordCount": "{count} words"
  },
  "documentFailure": {
    "audio-no-speech": "No speech could be heard in the recording",
    "audio-too-large": "The recording is over {limit} MB, the most that is transcribed: upload a shorter or more compressed copy",
    "credit-exhausted": "No credit left: new documents are not processed",
    "endpoint-off": "The organization's own AI endpoint is switched off",
    "file-protected": "The file is password protected: upload a copy without the password",
    "file-type-unsupported": "This type of file cannot be read",
    "file-unreadable": "The file is damaged, or not in the format its name says",
    "format-unsupported": "The endpoint's model cannot read this format with the AI description: use the normal conversion",
    "gateway-disabled": "It needs the platform AI gateway, which this organization does not use",
    "model-unavailable": "The model chosen for documents is not switched on for this organization",
    "no-model": "No model is set for the AI of documents",
    "page-too-large": "The page is too heavy to be read, even without its scripts and inline graphics",
    "source-status": "The source page answered HTTP {status}",
    "spreadsheet-macros": "The workbook contains macros: save it as an .xlsx without macros",
    "spreadsheet-no-table": "No sheet has a header row in its first thirty rows, so there is no table to query",
    "spreadsheet-protected": "The file is password protected, or an old .xls renamed to .xlsx: upload an unprotected .xlsx copy",
    "spreadsheet-too-large": "Too large to be read as tables: its content takes more than {limit} MB",
    "spreadsheet-unreadable": "The file is not a valid .xlsx workbook",
    "transcription-off": "Audio is transcribed on the platform AI gateway, which this organization does not use"
  },
  "documentRefreshResult": {
    "failed": "Failed",
    "gone": "Page gone",
    "shrunk": "Refused",
    "unchanged": "Unchanged",
    "updated": "Updated"
  },
  "documentStatus": {
    "failed": "Failed",
    "pending": "Pending",
    "processing": "Processing",
    "success": "Converted"
  },
  "searchStatus": {
    "indexed": {
      "label": "Available",
      "title": "Available for the agent's search"
    },
    "pending": {
      "label": "Preparing",
      "title": "On its way to the agent's search index"
    },
    "failed": {
      "label": "Not indexed",
      "title": "The search index did not take the document: reprocess it to try again"
    },
    "unavailable": {
      "label": "Unavailable",
      "title": "The organization cannot compute embeddings: the document stays out of the search until the gateway or the organization's endpoint is back on"
    },
    "empty": {
      "label": "No content",
      "title": "The document has no text to search"
    }
  },
  "documentSyncCounter": {
    "scanned": "files checked",
    "added": "added",
    "updated": "updated",
    "renamedOrMoved": "renamed or moved",
    "removed": "removed",
    "unchanged": "unchanged",
    "skippedUnsupported": "unsupported formats",
    "skippedTooLarge": "too large",
    "failed": "failed",
    "scannedPages": "pages checked",
    "capped": "left for the next check"
  },
  "documentSyncInterval": {
    "daily": "Every day",
    "hourly": "Every hour",
    "monthly": "Every month",
    "weekly": "Every week"
  },
  "documentSyncStatus": {
    "pending": "First import in progress",
    "syncing": "Syncing",
    "idle": "Up to date",
    "error": "Error"
  },
  "documentTrash": {
    "back": "Back to documents",
    "columnDeletedAt": "Deleted on",
    "columnDeletedBy": "Deleted by",
    "columnPurgedIn": "Deleted for good in",
    "daysLeft": "At the next cleanup | {count} day | {count} days",
    "empty": "The trash is empty.",
    "emptyConsequence": "The original files and the extracted text are destroyed: they can no longer be restored or downloaded. A document shared with other agents leaves their trash too.",
    "emptyQuestion": "The document in the trash is deleted permanently. | The {count} documents in the trash are deleted permanently.",
    "emptySuccess": "{count} document deleted permanently. | {count} documents deleted permanently.",
    "emptyTitle": "Empty the trash?",
    "emptyTrash": "Empty trash",
    "intro": "The agent no longer searches the documents in the trash. You can restore them or delete them permanently.",
    "introRetention": "Each document stays here for {count} day, then it is deleted for good. | Each document stays here for {count} days, then it is deleted for good.",
    "openLiveDocument": "Open the document in its place",
    "purge": "Delete permanently",
    "purgeConsequence": "The original file and the extracted text are destroyed: it can no longer be restored or downloaded.",
    "purgeQuestion": "\"{name}\" is deleted permanently.",
    "purgeSuccess": "Document deleted permanently.",
    "purgeTitle": "Delete permanently?",
    "refusalAgentGone": "Every agent this document belonged to has been deleted, so there is nowhere to restore it. It can only be deleted permanently.",
    "refusalIdentityTaken": "The same source has imported this file again: restoring it would make two copies of one document. Use the one already in the knowledge base.",
    "restore": "Restore",
    "restoreCredits": "Indexing computes the embeddings of the document again and uses credits.",
    "restoreFailed": "The document could not be restored.",
    "restoreIndexing": "It becomes searchable again only once it is indexed, which happens in the background.",
    "restoreQuestion": "\"{name}\" goes back to the knowledge base of the agent, in its folder.",
    "restoreSuccess": "Document restored. It becomes searchable once it is indexed.",
    "restoreSuccessRoot": "Document restored at the root, because its folder no longer exists. It becomes searchable once it is indexed.",
    "restoreTitle": "Restore the document?",
    "toggle": "Trash",
    "toggleHint": "Documents deleted from this agent, which can still be restored"
  },
  "documentType": {
    "file": "File",
    "plain-text": "Plain text",
    "revised-answer": "Revised answer",
    "url": "Web page"
  },
  "errors": {
    "ACCOUNT_TEMPORARILY_LOCKED": "Too many wrong codes: verification is locked for 15 minutes.",
    "BANNED_USER": "This account has been banned. Contact support if you think this is a mistake.",
    "CREDENTIAL_ACCOUNT_NOT_FOUND": "This account signs in with Google or Microsoft and has no password to change",
    "EMAIL_CODE_NOT_AVAILABLE": "This account uses an authenticator app: enter its code or a backup code.",
    "TWO_FACTOR_REQUIRED": "An organization of this account requires two-step verification: set it up to continue",
    "PASSKEY_PASSWORD_REQUIRED": "Confirm your password to add a passkey",
    "PASSKEY_RECENT_SIGN_IN_REQUIRED": "Sign out and sign in again to add a passkey",
    "PASSKEY_NOT_ALLOWED_FOR_SESSION": "Passkeys can be added only by the account owner, signed in",
    "PASSKEY_USER_VERIFICATION_REQUIRED": "This passkey did not ask for a PIN, a fingerprint or a face: set one up on the device and try again",
    "PASSKEY_NOT_FOUND": "This passkey is not linked to any account: sign in with your password",
    "AUTHENTICATION_FAILED": "The passkey could not be verified: try again",
    "FAILED_TO_VERIFY_REGISTRATION": "The passkey could not be saved: try again",
    "CHALLENGE_NOT_FOUND": "The request expired: try again",
    "EMAIL_NOT_VERIFIED": "Verify your email address",
    "EMAIL_VERIFICATION_REQUIRED_BEFORE_ACCEPTING_OR_REJECTING_INVITATION": "Verify your email address before answering the invitation",
    "FAILED_TO_UNLINK_LAST_ACCOUNT": "You cannot unlink your only sign-in method",
    "INVALID_BACKUP_CODE": "The backup code is not valid or has already been used.",
    "INVALID_CODE": "The code is not valid. Try again.",
    "INVALID_EMAIL_OR_PASSWORD": "Invalid email or password",
    "INVALID_PASSWORD": "The password is not correct",
    "INVALID_TOKEN": "This link has expired or has already been used. Request a new one.",
    "INVALID_TWO_FACTOR_COOKIE": "The verification has expired. Sign in again.",
    "INVITATION_LIMIT_REACHED": "This organization has reached its invitation limit",
    "INVITATION_NOT_FOUND": "The invitation is no longer valid: it may have expired, been cancelled or already been answered",
    "INVITER_IS_NO_LONGER_A_MEMBER_OF_THE_ORGANIZATION": "The person who invited you is no longer in the organization, so the invitation is no longer valid",
    "KEY_NOT_FOUND": "The API key no longer exists: it may have already been deleted",
    "MEMBER_NOT_FOUND": "Member not found in the organization",
    "NOT_ALLOWED": "You do not have permission to do this",
    "ORGANIZATION_ALREADY_EXISTS": "An organization with this slug already exists",
    "ORGANIZATION_MEMBERSHIP_LIMIT_REACHED": "This organization has reached its member limit",
    "ORGANIZATION_NOT_FOUND": "The organization no longer exists",
    "ORGANIZATION_SLUG_ALREADY_TAKEN": "This slug is already used by another organization",
    "OTP_HAS_EXPIRED": "The code has expired. Ask for a new one.",
    "RATE_LIMIT_EXCEEDED": "Rate limit exceeded",
    "SESSION_NOT_FRESH": "For your security, sign in again and repeat the operation",
    "SOCIAL_ACCOUNT_ALREADY_LINKED": "This account is already linked to another user",
    "TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE": "Too many attempts. Sign in again to get a new code.",
    "TOO_MANY_REQUESTS": "Too many attempts. Wait a few minutes and try again.",
    "TOTP_ALREADY_ENABLED": "Two-step verification with an app is already on.",
    "TOTP_NOT_ENABLED": "No authenticator app is set up for this account.",
    "TWO_FACTOR_REQUIRED_TO_ENFORCE": "Turn on two-step verification on your own account before requiring it.",
    "UNAUTHORIZED_SESSION": "Your session has expired. Sign in again.",
    "USER_ALREADY_EXISTS": "An account with this email already exists",
    "USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL": "An account with this email already exists",
    "USER_IS_ALREADY_A_MEMBER_OF_THIS_ORGANIZATION": "This user is already a member of the organization",
    "USER_IS_ALREADY_INVITED_TO_THIS_ORGANIZATION": "This user has already been invited to the organization",
    "USER_IS_NOT_A_MEMBER_OF_THE_ORGANIZATION": "You are not a member of this organization",
    "USER_NOT_FOUND": "The user no longer exists",
    "YOU_ARE_NOT_A_MEMBER_OF_THIS_ORGANIZATION": "You are not a member of this organization",
    "YOU_ARE_NOT_ALLOWED_TO_MANAGE_TWO_FACTOR": "Only a system administrator, signed in as themselves, can do this.",
    "YOU_ARE_NOT_THE_RECIPIENT_OF_THE_INVITATION": "This invitation was sent to another email address",
    "YOU_CANNOT_BAN_YOURSELF": "You cannot ban yourself",
    "YOU_CANNOT_IMPERSONATE_ADMINS": "You cannot impersonate an administrator",
    "YOU_CANNOT_LEAVE_THE_ORGANIZATION_AS_THE_ONLY_OWNER": "You are the only owner: make someone else an owner before leaving",
    "YOU_CANNOT_LEAVE_THE_ORGANIZATION_WITHOUT_AN_OWNER": "The organization needs at least one owner",
    "YOU_CANNOT_MANAGE_YOUR_OWN_TWO_FACTOR": "Your own two-step verification and passkeys are managed from your profile.",
    "YOU_CANNOT_REMOVE_YOURSELF": "You cannot remove yourself",
    "YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_ORGANIZATIONS": "You have reached the maximum number of organizations",
    "fileAlreadyImported": "This file has already been imported as a document",
    "invalidToken": "Request no longer valid",
    "passwordsDoNotMatch": "Passwords do not coincide",
    "privateNetworkRequired": "Confirm that this endpoint is on a private network",
    "refreshIntervalUrlOnly": "Only web pages can update themselves",
    "required": "Required",
    "slugAlreadyExists": "The slug already exists",
    "slugFormat": "The slug can only contain lowercase letters, numbers, and hyphens (-)",
    "urlAlreadyImported": "This URL has already been imported as a document",
    "syncSourceUrlOnly": "Only a web page can belong to a web source"
  },
  "externalProvider": {
    "domain": "Email domain",
    "github": "GitHub",
    "google": "Google",
    "microsoft": "Microsoft Entra"
  },
  "feature": {
    "agentVisibilityPublic": "Public",
    "agentVisibilityRegistered": "Signed-in users",
    "agentVisibilityRestricted": "Private",
    "apiTools": "API tools",
    "byok": "Own models (BYOK)",
    "endpoints": "API endpoints",
    "fileUpload": "File upload",
    "gateway": "Platform models",
    "group": {
      "channels": "Channels and publishing",
      "models": "Models",
      "tools": "Tools and data",
      "visibility": "Agent visibility"
    },
    "hostTools": "Embedding page tools",
    "hubspot": "HubSpot",
    "leads": "Contacts",
    "legend": "Features",
    "mcpServers": "MCP servers",
    "openaiApi": "OpenAI API",
    "proactiveAutomations": "Proactive automations",
    "salesforce": "Salesforce",
    "sharepoint": "SharePoint",
    "subAgents": "Sub-agents",
    "teams": "Microsoft Teams",
    "voice": "Voice conversation",
    "whatsapp": "WhatsApp"
  },
  "gdprRetention": {
    "anonymousLabel": "Anonymous user erasure",
    "chatLabel": "Chat anonymization",
    "defaultDays": "Default: {count} day. | Default: {count} days.",
    "defaultDisabled": "Default: disabled.",
    "legend": "Data retention (GDPR)",
    "trashLabel": "Trash emptying",
    "unitDays": "days"
  },
  "help": {
    "aiDescription": "An AI model analyzes the file and generates a structural description of the content. Useful for documents with tables, charts, or complex layouts.",
    "aiDescriptionModel": "The AI model used to generate the description.",
    "aiDescriptionPrompt": "Prompt used to generate the description",
    "browserEngine": "How the page is loaded before extraction",
    "documentFile": "PDF, Word, Excel, CSV, text, images and audio.",
    "fetchBrowserEngine": "fast, fetches the static HTML. Best for most sites.",
    "followExternal": "Retrieve links from different domains",
    "forceOcr": "Force text extraction via OCR (Document Intelligence). Useful for scanned PDFs or when the normal extraction produces insufficient results.",
    "pages": "Empty: all pages. Pages are read with OCR.",
    "puppeteerBrowserEngine": "runs JavaScript with a local browser. For dynamic or single-page apps.",
    "remoteBrowserEngine": "like Puppeteer, but on a remote browser. Bypasses blocks and bot detection.",
    "useBrowserEngine": "Slower, but allows analysis of dynamic pages",
    "useExtractionStrategy": "Improve data extraction with AI",
    "webSourceWatch": "New pages go into the folder “{name}”.",
    "webSourceRemoveMissing": "For a complete sitemap. Many removals wait for you.",
    "webSourceRemoveMissingExplained": "For a site of your own, whose sitemap lists everything published. If too many go missing at once, nothing is removed until you confirm."
  },
  "hint": {
    "agentModel": "Pre-selected when you create a new agent.",
    "agentOnOwnEndpoint": "This agent runs on your organization's endpoint.",
    "allowedDomains": "Only search within these domains.",
    "approvalChannels": "A tool can ask the user to confirm before it runs: expand a tool to turn it on. On API endpoints and scheduled runs the call is refused.",
    "approvalChannelsApiTools": "A tool can ask the user to confirm before it runs: turn it on from Edit, in the tool's menu. On API endpoints and scheduled runs the call is refused.",
    "audience": "Expected aud of the JWT. Empty: not checked.",
    "blockedDomains": "Exclude these domains from results.",
    "channel": {
      "app": "The agent is accessible via the dedicated public page.",
      "frontoffice": "The agent appears in the platform: on the Try page and the other Monitor pages.",
      "widget": "The agent can be embedded in websites via embed script."
    },
    "channelAppDisabled": "The App channel is disabled: the direct link and iframe will not work.",
    "channelWidgetDisabled": "The Widget channel is disabled: the embed code and loader will not work.",
    "costSourceEndpoint": "The models on your organization's endpoint: your provider bills them, the cost here is a list-price estimate.",
    "customCss": "CSS injected into the widget shadow DOM. Allows styling the chat interface from the outside.",
    "disallowPromptTraining": "Route requests only to providers that do not use your data to train AI models.",
    "dismissableNotice": "It will be hidden after the first message.",
    "documentFolderManaged": "Folder synced from {provider}: its content is changed at the source.",
    "documentRefresh": "Reads the page again when due and regenerates only what changed.",
    "documentRefreshTriggerOff": "This page updates itself, and saving your own text stops that.",
    "documentSelectionHasManaged": "The selection contains documents that come from a connected source and cannot be changed by hand.",
    "documentSourceInterval": "How often the folder is read again.",
    "documentSourceIntervalExplained": "How often the folder is read again. Files that have not changed are not converted again.",
    "documentSourceName": "The name this folder has here. The remote one does not change.",
    "emailClaim": "The JWT claim containing the user email (default: email).",
    "embedCode": "Copy and paste this code to embed the agent in your website.",
    "embedding": "The vectors of the knowledge base, of the users' files and of the memories. They are computed on the platform AI gateway, or on your endpoint with one of the two models it can serve.",
    "embeddingActivation": "Before saving, the endpoint embeds a test sentence and its vector is compared with the model's own: a different model is refused. Moving to another model embeds the knowledge base and the memories again, and until it is done the searches find only what is already in the new model.",
    "embeddingEndpointModel": "The id your endpoint serves the model under",
    "embeddingEndpointOff": "Switch the endpoint on to compute the vectors there",
    "embeddingFamily": "Among those your endpoint serves",
    "embeddingFamilyUnknown": "Your endpoint does not declare it: the save checks it",
    "embeddingModelsServed": "Your endpoint serves these too. They cannot answer an agent: the one the vectors are computed with is chosen in the Embedding section.",
    "embeddingNotConfigured": "The knowledge base, the corrected answers, the memories and the document processing are stopped, because nothing computes their vectors. Activate an embedding model on your endpoint to start them again.",
    "embeddingReindexing": "Until the reindex ends, the searches in the knowledge base and in the memories find only what is already in the new model: partial results, never wrong ones. Nothing has to be done, and an interrupted run picks up where it stopped.",
    "embeddingStopped": "The endpoint that computes the vectors is off: the knowledge base, the corrected answers, the memories and the document processing are stopped until you switch it back on.",
    "embeddingWithoutEndpoint": "The vectors of the knowledge base, of the users' files and of the memories are computed on the platform AI gateway. Connect your endpoint to compute them there.",
    "embedIframe": "Embed the chat interface directly using an iframe. ",
    "embedPreview": "The agent will be accessible at the following URL.",
    "embeddingWithoutEndpointOrGateway": "The vectors of the knowledge base, of the users' files and of the memories are not computed: this organization does not use the platform AI gateway. Connect your endpoint to compute them there.",
    "embeddingWithoutGateway": "The vectors of the knowledge base, of the users' files and of the memories. This organization does not use the platform AI gateway, so they are computed only on your endpoint, with one of the two models allowed.",
    "externalContextSchema": "Define which contextual data the hosting site can send to the agent.",
    "externalContextSchemaToggle": "Enable receiving contextual data from the hosting site.",
    "feature": {
      "agentVisibilityPublic": "Agents are used without signing in too, for example from the widget on a public website.",
      "agentVisibilityRegistered": "Agents are used with any account, of other organizations too: anyone can sign up.",
      "agentVisibilityRestricted": "Only owners, admins and the members enabled for them use the agents.",
      "apiTools": "Agents call the organization's own APIs as tools.",
      "byok": "The organization connects its own OpenAI compatible endpoint and uses its models.",
      "endpoints": "Agents answer other systems over REST.",
      "fileUpload": "Users attach files to their chat messages.",
      "gateway": "The AI gateway models, and with them the platform's embedding, and the utilities and the document AI that use them.",
      "hostTools": "Agents use the tools of the app embedding the chat and the page hosting the widget.",
      "hubspot": "Leads collected by the agents go to the organization's HubSpot CRM.",
      "leads": "Agents collect contacts with a form in the chat, and the Contacts page lists them.",
      "mcpServers": "Agents use the tools of external MCP servers.",
      "openaiApi": "Agents answer as models to n8n, LangChain and any OpenAI compatible client.",
      "proactiveAutomations": "Agents check again by themselves what the user asks them to keep an eye on.",
      "salesforce": "Leads collected by the agents go to the organization's Salesforce CRM.",
      "sharepoint": "Agents read the files of SharePoint folders kept in sync.",
      "subAgents": "An agent calls another one as a tool.",
      "teams": "Agents answer in Teams chats.",
      "voice": "Agents talk with the user in real time.",
      "whatsapp": "Agents answer on WhatsApp Business."
    },
    "featureInfo": {
      "hostTools": "Off, no agent offers them, not even the ones already set up.",
      "proactiveAutomations": "Off, the checks under way stop at their next round."
    },
    "fallbackModels": "Alternative models tried in order if the primary model is unavailable.",
    "featureVisibilityOrganization": "Organization is always available: it is the visibility of every new agent. A visibility some agent uses cannot be switched off.",
    "fieldMappingFallback": "Value used if the source field is empty or missing.",
    "fieldMappingSource": "Supports nested paths (e.g. metadata.urgency).",
    "fieldMappingTransformExtractDomainCompany": "Extracts the company name from the email domain (e.g. mario{'@'}acme.com → Acme). Skips free providers (gmail, outlook, etc.).",
    "fieldMappingTransformJoinArray": "Joins array values into a comma-separated string.",
    "fieldMappingTransformMapValues": "Replaces the value using the value map lookup table.",
    "fieldMappingTransformNone": "Copies the value as-is.",
    "fieldMappingTransformSplitFirstLast": "Splits text on spaces.",
    "fileUploadDisabledHint": "File upload is not enabled for this agent. You can enable it in the agent settings.",
    "fileUploadEnabled": "Allow users to attach files to their messages.",
    "fileUploadToolOff": "{types}: users cannot attach them while the tool that opens them is off. You find it further down, among the tools.",
    "mimeTypeImages": ".jpg, .png, .gif, .webp",
    "mimeTypePdf": "Documents and slides saved as .pdf",
    "mimeTypeText": ".txt, .md, .csv",
    "mimeTypeCode": ".html, .js, .json, .py, .sql and more",
    "mimeTypeSpreadsheets": ".xlsx",
    "mimeTypeWordDocuments": ".docx",
    "mimeTypeAudio": ".mp3, .m4a, .wav and more (transcribed, up to 25 MB)",
    "freshnessBoost": "Applies a boost based on how recently the document was updated.",
    "freshnessScale": "Freshness scale (days)",
    "freshnessScaleExplanationDays": "A document updated today gets a +{weight} bonus. This bonus halves to +{halfWeight} after {half} days and practically drops to zero (+{zeroWeight}) after {zero} days.",
    "freshnessScaleExplanationMonths": "A document updated today gets a +{weight} bonus. This bonus halves to +{halfWeight} after {half} days and practically drops to zero (+{zeroWeight}) after {zero} days (approx. {months} months).",
    "freshnessScaleTooltip": "The half-life of the exponential decay. A document as old as this value will receive 50% of the maximum boost. Lower values cause older documents to lose the boost more quickly.",
    "freshnessWeight": "Weight multiplier of the freshness boost in the formula.",
    "freshnessWeightTooltip": "Maximum score bonus added to newly updated documents. A weight of 0.1 means a brand new document gets a +0.10 score advantage. This bonus decays exponentially over time until it reaches zero.",
    "greeting": "On the chat page, in large type above the message field until the user writes. Left empty, the suggested text shows. {'{'}name{'}'} becomes the user's name.",
    "gatewayCatalog": "The models the platform makes available, with the price per million tokens, the context size and the data privacy guarantees. Switch off the ones your organization does not use: they leave the pickers, and an agent still on one answers with the default model.",
    "gatewayOffDisconnected": "Unless its own endpoint is on and serves models, the organization is disconnected: no agent answers.",
    "gatewayOffNoByok": "Own models (BYOK) are off too: its administrator can neither set up an endpoint nor switch one on or off, nor move the embedding.",
    "gatewayOffStops": "Switched off, nothing of this organization reaches the gateway, within thirty seconds: the gateway models stop answering, and so do the internal utilities on them; the web search stops. The knowledge base, the corrected answers, the memories and the document processing go on only if the embedding is on the organization's own endpoint: on the platform's, they stop.",
    "gatewayOffTodo": "The administrator has to move both default models to the organization's own endpoint, or new agents cannot be created, and the embedding too (Models, Embedding section), or the knowledge base and the memories stay stopped. The inference is no longer charged to the credit; the voice minutes and the document OCR still are.",
    "glowSecondColorCustom": "When off, the second tone is picked automatically.",
    "glowTonesAuto": "Two tones if the color is black, white or gray.",
    "glowTonesOne": "One light behind the message field.",
    "glowTonesTwo": "Two lights blending behind the message field.",
    "guaranteeAll": "{name}: guaranteed on every provider.",
    "guaranteeNone": "{name}: not guaranteed.",
    "guaranteeSome": "{name}: guaranteed on some providers only, the gateway routes accordingly.",
    "hostToolNameInvalid": "Lowercase letters, digits and underscores, starting with a letter.",
    "hostToolNameReserved": "Names starting with page_ or form_ are reserved for page tools.",
    "hostTools": "The app that embeds the chat declares its tools and runs them itself.",
    "hostToolsConfirmDestructive": "Also ask before the tools the app declares as destructive.",
    "hostToolsEnabled": "Off, the agent sees none of the app's tools, whatever it declares.",
    "hostToolsInfo": "The app is the widget, or the /app page in an iframe. Only the tools allowed in this section reach the model.",
    "hostToolsLabel": "Shown in the chat steps and in the prompt, for example “Acme Sheets”.",
    "hostToolsMaxCallsPerTurn": "Past it, the agent answers with what it has.",
    "hostToolsNeedsOrigins": "The /app page in an iframe accepts as host only explicit trusted origins (in Security, without “*”). The widget does not need them.",
    "hostToolsRequireConfirmation": "The user confirms before each call, whatever the app declares.",
    "hostToolsTimeout": "Past it, the call closes with no answer.",
    "includeThoughts": "Streams the model's thoughts to the client along with the response.",
    "inputSchema": "JSON Schema (draft-07) of the input parameters the LLM can provide.",
    "integrationOAuthAdminConsent": "A Microsoft 365 administrator of your organization may need to approve this.",
    "integrationAppCredentialScope": "With Sites.Read.All the app can read every site of the tenant. The connector reads only the folders you link.",
    "integrationAppCredentialSteps": "In Microsoft Entra ID: App registrations, New registration. Then API permissions, Microsoft Graph, Application permissions, Sites.Read.All, and Grant admin consent. Then Certificates & secrets, New client secret (note when it expires). Copy the Directory (tenant) ID, the Application (client) ID and the secret value here.",
    "interactiveLogin": "Lets anonymous users sign in from the chat. The external token stays active.",
    "invalidCssSelector": "Invalid CSS selector: while it stays, page access is off.",
    "issuer": "The issuer URL of the JWT token (iss).",
    "jwksUrl": "The JWKS endpoint URL for JWT signature verification.",
    "loadDelay": "Wait before loading, for slow AMD loaders.",
    "loaderStrategy": {
      "dynamic-import": "Uses import() inside a classic <script>. Fallback for pages where module scripts are blocked or intercepted by legacy loaders.",
      "inline-module": "Injects an inline <script type=\"module\"> with a static import. Bypasses RequireJS and other AMD loaders. Recommended for most sites.",
      "script-src": "Loads the bundle via <script type=\"module\" src=\"...\">. Use this on sites with strict Content Security Policy (CSP) that block inline scripts."
    },
    "mcpServerHealthCheckPath": "The endpoint used to check the health of the MCP Server (e.g., /api/health).",
    "mcpStatelessServer": "Force the client to connect in stateless mode.",
    "mcpHeadersOriginChanged": "The URL points to another host: type the values of the headers again, the saved ones stay with the previous host.",
    "mcpExternalToken": "The server receives, as Authorization: Bearer, the token the user authenticated with through the external authentication of the organization: from the widget signed in with that token, or from a call to the OpenAI compatible API that carries it. This page carries none, so it cannot run the health check, and it lists the tools seen at the last call that did.",
    "mcpExternalTokenTools": "These are the tools the server offered at the last call that carried a user's token: this page cannot ask it now.",
    "mmr": "Balances semantic relevance and document diversity in search results to avoid redundant content.",
    "mmrCandidatesLimit": "Maximum number of candidate chunks pre-selected before applying MMR.",
    "mmrCandidatesLimitTooltip": "The number of top candidate chunks retrieved from the database before applying the MMR diversity filter. For example, if set to 100, the system selects the 100 highest-scoring chunks first, then filters them to find the most diverse subset.",
    "mmrDiversity": "Tradeoff between relevance (0.0) and diversity (1.0).",
    "mmrDiversityTooltip": "Controls how diverse the search results should be. A value near 0 focuses solely on relevance (even if results are similar). A value near 1 forces the inclusion of results with different details and themes, reducing redundancy.",
    "modelContextWindow": "Context window: {count}k tokens.",
    "modelDefaultNoneAvailable": "No model available: switch on at least one model of your endpoint below.",
    "modelDefaultOutsideCatalog": "This model is not among those available to your organization: pick another one. Meanwhile new agents start on the platform's standard model.",
    "modelDefaults": "They apply to the whole organization. Each agent can still use a different model, chosen in its own settings.",
    "modelDisabledForOrganization": "Switched off for this organization: the agents still on it answer with the default model, and it cannot be picked for a new one.",
    "modelEndpointBaseUrl": "The base address of the OpenAI compatible API.",
    "modelEndpointHttp": "Over http the key travels unencrypted: use it only if the endpoint is reachable from your internal network alone.",
    "modelEndpointHttpTitle": "Unencrypted connection (http)",
    "modelEndpointKey": "It is stored encrypted and never shown again.",
    "modelEndpointKeyStored": "Already saved. Leave the field empty to keep it.",
    "modelEndpointName": "The name you will recognise it by when choosing models.",
    "modelEndpointOffWithEmbedding": "Endpoint off: its models are not available, the agents on them stop answering, and the knowledge base, the memories and the documents stop with it, because it computes their vectors. Turn it back on to start them again.",
    "modelEndpointOnWithoutGateway": "Endpoint on: the models you switch on are the only ones the agents can use, since this organization does not use the platform gateway, and can be the defaults.",
    "modelNotOnEndpoint": "Not available to this organization: its endpoint no longer has this model, so an agent on it does not answer until it is moved to another model.",
    "modelSourceEndpoint": "Runs on {name}, your organization's own endpoint: your provider bills it, and the costs shown here are estimated from the price list.",
    "modelSourceOff": "Not available to this organization: the source it runs on is switched off, so an agent on it does not answer until it is moved to another model or the source is switched back on.",
    "modelSourcePlatform": "Runs on the platform AI gateway and is paid with your organization's credit.",
    "ownEndpoint": "Use your own models next to the platform ones: connect an OpenAI compatible endpoint with your own key. The agents that run on its models are not charged to your credit.",
    "modelEndpointOn": "Endpoint on: the models you switch on are available to the agents next to the platform ones, and can be the defaults.",
    "modelEndpointOff": "Endpoint off: its models are not available, and the agents on them stop answering. Switch on the models you need below, then turn it on.",
    "addModelsRule": "Switch on the models your agents will be able to use. The price comes from the platform price list; if a model is not in the list, you will be asked to enter it.",
    "modelPriceAsk": "This model is not in the platform price list. Pick a catalog model with a similar cost, or enter the prices per million tokens.",
    "modelPriceUnknown": "Not in the platform price list: enter a price.",
    "modelGuaranteedOnSome": "The guarantees you switched on hold only on some providers of this model: the gateway routes accordingly.",
    "modelIdByHand": "The technical name the endpoint uses to identify the model.",
    "modelNotCompatible": "Not compatible with the privacy flags of this agent.",
    "modelPriceFromListing": "Price taken from {id} in the platform price list.",
    "modelPriceListing": "Platform price list, entry {id}, updated on {date}.",
    "modelPriceManual": "Price typed by hand on {date}.",
    "modelPriceReference": "Same price as {id}, updated on {date}.",
    "modelReference": "A catalog model this one costs like.",
    "modelRetired": "No longer available on the platform: move the agents using it to another model.",
    "moveDocument": "Choose the destination folder for «{name}».",
    "moveDocuments": "Choose the destination folder for {n} document. | Choose the destination folder for {n} documents.",
    "multipleChoiceAllowCustomAnswer": "Show a free-text field below the options so the user can type a custom answer.",
    "multipleChoiceMaxOptions": "Maximum number of options the AI can generate (min. 2, max. 10).",
    "nameClaim": "Claim with the user name (default: name).",
    "oauthCallbackUrl": "Set this URL as the Callback URL (Redirect URI) in the OAuth provider.",
    "outputSchema": "JSON Schema (draft-07) of the expected response. Informational only.",
    "pageAccess": "The agent reads the page of the site that embeds the widget and, at the higher levels, uses it. Only in the widget.",
    "pageAccessAccepted": "Risk accepted on {date}.",
    "pageAccessConfirmEveryAction": "The user confirms every click and every write, not only submits and page changes.",
    "pageAccessExcludeSelectors": "The agent neither reads nor touches these elements and those with the data-agent-ignore attribute.",
    "pageAccessExcludeSelectorsInfo": "Passwords, hidden fields and payment data are already excluded: other sensitive fields have to be marked by the site.",
    "pageAccessLevel": {
      "forms": "It also fills in the forms the site annotated for agents.",
      "full": "It also clicks and types on the page for the user, who sees it act and can stop it.",
      "off": "The agent neither reads nor uses the page.",
      "read": "The agent reads the visible part of the page to answer."
    },
    "pageAccessNeedsOrigins": "Without explicit trusted origins (in Security, without “*”) the agent stays at reading: it has to know which sites embed it.",
    "pageAccessNotAccepted": "The risk of this level has not been accepted: until you accept it, the agent only reads the page.",
    "pageAccessNotice": "Empty, the widget uses the level's own text.",
    "pageAccessPointer": "A button in the chat input to point at an element of the page, or select its text, and ask about it.",
    "pageAccessRisk": {
      "forms": "The agent fills in the forms the site annotated and submits them where the site allows it.",
      "full": "The agent clicks and types with the user's session on that site, and malicious text on the page (a comment, a review) may try to steer it. Protect sensitive areas with data-agent-ignore or with excluded areas.",
      "read": "The visible content of the page, personal data included, goes to the model provider, under the agent's retention rules."
    },
    "passphrase": "Enter {passphrase} to confirm the operation",
    "platformSupported": "Renders natively on WhatsApp and Teams",
    "privacyPolicyNotice": "At the foot of the contact form, in Markdown.",
    "providerOrganizationId": "For Microsoft this refers to the tenant identifier (tenant ID). \nFor others, enter the email domain (e.g. company.com).",
    "providerTimeoutMs": "1000-789000, then the next one. BYOK only.",
    "reasoningDefault": "The platform's default value.",
    "reasoningNotSupported": "Reasoning is not supported for the selected provider.",
    "privateSubAgent": "Private: it can be a sub-agent only of a Private agent",
    "reasoningVisibility": "A reasoning agent is used within its organization only: Organization or Private.",
    "sessionExpiresIn": "Seconds, at least 60. Empty: 8 hours.",
    "showExtendedSteps": "Shows reasoning and tool calls as an expandable timeline in the chat.",
    "showReasoning": "Turned off, the chat says the agent is reasoning without showing its text.",
    "smoothStream": "Smooths text streaming creating a more natural reading experience.",
    "subAgentName": "Only letters, numbers, underscores (_) and hyphens (-) are allowed.",
    "subAgentToolName": "The tool name is built from what you type here.",
    "teamsAccentColor": "Defaults to the agent's theme color.",
    "teamsAppVersion": "Raise it and reinstall to apply manifest changes.",
    "tool": {
      "createSpreadsheet": "On request, creates a new Excel file to download, then edits it.",
      "createWordDocument": "On request, creates a new Word document to download, then edits it.",
      "fetchTeamsChannelHistory": "Reads the wider conversation of a Teams channel on demand.",
      "geocode": "Converts place names to geographic coordinates and vice versa.",
      "getWeather": "Fetches current weather data and forecasts for a specific location.",
      "querySpreadsheet": "Exact counts and totals on the Excel and CSV files of the knowledge base.",
      "readDocumentFile": "Reads the original knowledge base PDF or DOCX, with its tables and charts.",
      "requestGeolocation": "Requests the user's GPS location via the browser.",
      "retrieveRevisedAnswers": "Uses the answers verified by administrators as the primary source.",
      "runWorker": "Runs workers with its tools for independent sub-tasks in parallel.",
      "scheduleWakeup": "On request, checks something again at intervals and posts what is new.",
      "searchInKnowledgeBase": "Searches the knowledge base documents to answer.",
      "searchInUserFiles": "Searches the private files the user uploaded in chat.",
      "shareDocument": "On request, gives a link to download a knowledge base document.",
      "showArtifact": "Displays structured content such as formatted text, code, or documents.",
      "showCalendarEvent": "Shows an event with Google Calendar and Outlook links and an .ics file.",
      "showComparison": "Compares 2 to 4 items side by side to help the user decide.",
      "showContactForm": "Displays a contact form to collect user information.",
      "showDiagram": "Renders a chart or a diagram (flowchart, sequence, class, ER, state).",
      "showEmail": "Composes a ready-to-send email from the user's email client.",
      "showForm": "Collects text, numbers, dates and choices in a multi-step form.",
      "showImageGallery": "Collects images in a browsable gallery with zoom and lightbox.",
      "showLocation": "Displays an interactive map with a marker and directions.",
      "showMessage": "Composes a message to send via WhatsApp, Telegram, or SMS.",
      "showMultipleChoice": "Presents selectable options to guide the conversation flow.",
      "showProductList": "Shows a product list with images, descriptions, and purchase links.",
      "showQrCode": "Generates a QR code from text, URLs, or structured data.",
      "showSources": "Shows the knowledge base documents used in the answer.",
      "showSuggestedReply": "Suggests clickable replies to continue the conversation.",
      "showVideo": "Plays videos inline: direct files (MP4/WebM) or YouTube/Vimeo links.",
      "showWeather": "Displays a weather forecast widget directly in the chat.",
      "showWebPages": "Suggests links to web pages relevant to the user's question.",
      "spreadsheet": "Reads and edits Excel files attached in chat, on Teams and WhatsApp too.",
      "useAllUserFiles": "Searches all the user's files, including those uploaded on other agents.",
      "useAllUserKb": "Reads the memories the user shared with every agent of the organization.",
      "userMemory": "Remembers what the user shares across conversations (name, preferences).",
      "wordDocument": "Reads and edits Word documents attached in chat, on Teams and WhatsApp too."
    },
    "toolInfo": {
      "createSpreadsheet": "By turning this option on you accept that the agent puts in the file the data it reads in the conversation, in the knowledge base and from its tools. In the web chat and the widget for users with an account, and on Teams and WhatsApp.",
      "createWordDocument": "Such as an offer, a letter or minutes. By turning this option on you accept that the agent puts in the document the data it reads in the conversation, in the knowledge base and from its tools. In the web chat and the widget for users with an account, and on Teams and WhatsApp.",
      "fetchTeamsChannelHistory": "Requires reinstalling the Teams app.",
      "querySpreadsheet": "Turned off, the agent does not read these files at all. Spreadsheets attached in the chat go through the Spreadsheets tool.",
      "scheduleWakeup": "Intervals range from one minute to one hour.",
      "shareDocument": "A link to a file works for 7 days for anyone who has it, and stops if you turn the tool off; for a web page it gives the address. For the documents of a sub-agent, turn it on in the sub-agent too. With approval required, it does not work through the APIs.",
      "showSuggestedReply": "To have them after every answer, ask for it in the agent's instructions.",
      "spreadsheet": "On Teams only in direct chats. Each edit comes back as a new version to download. Needs Excel spreadsheets among the allowed file types.",
      "useAllUserKb": "Writing stays scoped to this agent.",
      "wordDocument": "On Teams only in direct chats. Each edit comes back as a new version, with tracked changes. Needs Word documents among the allowed file types."
    },
    "toolRequiresApproval": "The agent waits for approval in the chat before running.",
    "apiToolSecretParameters": "Sent with every call, in the query string or in the JSON body, and never shown to the model. Once saved a value is not shown again: leave it empty to keep it.",
    "apiToolSecretParametersNew": "Sent with every call, in the query string or in the JSON body, and never shown to the model. Type every value: once saved it is not shown again.",
    "apiToolSecretStored": "Saved: leave it empty to keep it",
    "apiToolCredentialInSchema": "These parameters look like credentials, and the model fills them in: {names}. Move them to the secret parameters and remove them from the input schema.",
    "apiToolCredentialBadge": "A parameter that looks like a credential is filled in by the model",
    "apiToolSecretsOriginChanged": "The URL points to another host: type the values of the headers and of the secret parameters again, the saved ones stay with the previous host.",
    "apiToolSecretBodyMethod": "A {method} request sends no body",
    "toolWorkingSetMode": {
      "active": "Before each reply, an evaluation model (TypeSafe Jev) picks the MCP servers, API tools and sub-agents the message needs, and the agent sees only those. When it needs another one, it brings it back on its own. Each evaluation is charged to the organization.",
      "off": "The agent sees every tool on every reply.",
      "shadow": "The evaluation model picks the tools each message needs, but the agent still sees them all: the choice is only recorded in the message detail, to compare it with the tools actually used before turning it on. Each evaluation is charged to the organization."
    },
    "useColorsForAgentHeader": "Color the agent header based on the main color.",
    "userFeedbackComment": "The user left a comment on this answer",
    "userFeedbackNegative": "The user rated this answer negatively",
    "userFeedbackPositive": "The user rated this answer positively",
    "userFeedbackReaction": "The user reacted to this answer",
    "utilityModel": "Used behind the scenes for tasks such as rephrasing user questions and updating memories.",
    "voiceApprovalRefused": "During a call these actions do not run: approval is given on screen and on the phone there is nobody to ask, so the agent refuses them and says so. Affected: {tools}.",
    "voiceCascadeTimeoutSeconds": "How long the provider waits for us before cancelling the turn. It must sit above the agent's slowest turn: a knowledge base, tools and slow models all stretch it.",
    "voiceEnabled": "Let people talk to this agent. The answer is still this agent, with its knowledge and tools.",
    "voiceFillerAfterSeconds": "Says it is working. Empty: 4 seconds.",
    "voiceFillerMessage": "Empty: a line in the voice language.",
    "voiceFirstMessage": "Said on pickup, covers the first turn.",
    "voiceId": "Cloned voices are not allowed here.",
    "voiceIgnoreBackgroundVoices": "Listen only to who is talking. Leave on where the microphone hears a room.",
    "voiceLanguage": "Used to recognise speech and to speak.",
    "voiceMaxSessionSeconds": "Billed by the minute, ends at this limit.",
    "voiceRemaining": "Time left in this call",
    "voiceSlowAgentOnCall": "A large knowledge base or connected MCP servers can take an agent several seconds to answer, and on a call those seconds are silence: the two settings below are what keeps the caller company while it works. If your calls feel slow, the answer itself gets shorter with fewer steps, a smaller retrieval limit or a faster model.",
    "voiceTurnEagerness": "Eager answers sooner, patient waits.",
    "voiceTurnTimeoutSeconds": "How long the agent lets the caller stay silent before speaking again. Nothing to do with how fast it answers.",
    "webSearchEnabled": "Allow the agent to search the web during conversations.",
    "webSearchNative": "Uses {provider}'s built-in web search capabilities.",
    "webSearchNativeFallback": "This model has no built-in web search: searches go through Perplexity.",
    "webSearchNativeWithoutSearch": "Uses {provider}'s built-in search; a fallback model without one does not search.",
    "webSearchNativeChain": "Each model uses its own provider's built-in search: {providers}.",
    "webSearchNativeChainWithoutSearch": "Each model uses its own provider's built-in search ({providers}); a fallback model without one does not search.",
    "webhookUrl": "Paste this URL into the platform's webhook / messaging endpoint configuration.",
    "welcomePopup": "Show a welcome popup with the initial message before the chat is opened.",
    "whatsappVerifyToken": "Paste this token into the Meta webhook configuration.",
    "widgetAppearanceSolid": "The chat has the theme's solid background.",
    "widgetAppearanceGlass": "The site shows through the chat, blurred; on a phone it stays solid.",
    "hideFloatingButton": "The chat opens only from a button on your site, which you add: it calls open() on the widget, see the README.",
    "copilotPageCss": "Added to your site's page while the chat is open beside it: move a fixed header aside with right: var(--chatbot-copilot-width).",
    "widgetLayoutCopilot": "Docked on one side, the site framed beside it.",
    "widgetLayoutFloating": "A button opens the chat in a card over the page.",
    "widgetUrl": "Keep the default address to load this installation's widget.",
    "workingGlow": "While the agent acts on the page, a light rises from the chat's corner. In the Copilot layout it runs along the site's edges instead, and along the chat's while the agent works.",
    "zeroDataRetention": "Route requests only to ZDR-compliant providers. Restricts the pool of available providers.",
    "webSourceUnselected": "Pages you leave unselected will arrive with the next checks of the source.",
    "webSourceInterval": "New pages follow the schedule above.",
    "webPagesRefresh": "When due, only what changed is regenerated.",
    "documentFolderWebSource": "Website folder: new pages arrive on their own and stay editable.",
    "invitationLanguage": "The language of the email the invited person receives."
  },
  "integrationProvider": {
    "hubspot": "HubSpot",
    "salesforce": "Salesforce",
    "sharepoint": "SharePoint",
    "web": "Website"
  },
  "integrationProviderDescription": {
    "hubspot": "Sync contacts and leads with HubSpot CRM.",
    "salesforce": "Sync contacts and leads with Salesforce CRM.",
    "sharepoint": "Link a SharePoint folder: its files join the knowledge base and stay up to date on their own."
  },
  "integrationSyncStatus": {
    "failed": "Failed",
    "pending": "Pending",
    "success": "Success"
  },
  "interval": {
    "D": "day | days",
    "M": "month | months",
    "W": "week | weeks",
    "Y": "year | years"
  },
  "invitationStatus": {
    "accepted": "Accepted",
    "canceled": "Canceled",
    "expired": "Expired",
    "pending": "Pending",
    "rejected": "Rejected"
  },
  "label": {
    "AI": "AI",
    "acceptInvitationAndCreateAccount": "Accept the invitation and create your account",
    "accountingCredit": "Accounting balance",
    "actions": "Actions",
    "active": "Active",
    "activeSessions": "Active sessions",
    "actualCost": "Actual cost",
    "addApiTool": "Add API tool",
    "addIntegration": "Add integration",
    "additionalMetadata": "Additional metadata",
    "admin": "Admin",
    "advancedOptions": "Advanced options",
    "agent": "Agent",
    "agentModel": "Default model",
    "agentTree": "Agent tree",
    "agents": "Agents",
    "agentsUsed": "Agents used",
    "aiDescription": "AI generated",
    "aiDescriptionModel": "AI model",
    "aiDescriptionPrompt": "Custom prompt",
    "allAgents": "All agents",
    "allChannels": "All channels",
    "allowedDomains": "Allowed domains",
    "analysis": "Analysis",
    "anonymized": "Anonymized",
    "anonymous": "Anonymous",
    "answer": "Answer",
    "answeringOnTheCall": "Answering…",
    "answeringInBackground": "Answering",
    "queued": "Queued",
    "queuedMessages": "Messages waiting to be sent",
    "apiKey": "API key",
    "apiKeys": "API keys",
    "appearance": "Appearance",
    "arrayOfObjects": "Array of objects",
    "assistantMessage": "Agent response",
    "attachmentsNotImported": "Attachments not imported",
    "attempts": "Attempts",
    "attention": "Attention",
    "audience": "Audience",
    "authentication": "Authentication",
    "auto": "Auto",
    "autoDetected": "Automatically detected",
    "autoProvisioning": "Auto provisioning",
    "autoProvisioningDescription": "Whoever signs in through these identity providers or domains joins your organization with the default role.",
    "autoRefreshError": "Error",
    "autoRefreshOff": "Paused",
    "autoRefreshOn": "Live",
    "autoRefreshStoppedErrors": "Automatic update stopped after repeated errors.",
    "autoRefreshStoppedUnavailable": "Automatic update stopped: this content is no longer accessible.",
    "autoRefreshWarning": "Warning",
    "availableCredit": "Available balance",
    "averageLine": "Average",
    "avgChatsPerUser": "Chats per user",
    "avgMessagesPerChat": "Messages per chat",
    "banned": "Banned",
    "baseUrl": "Base URL",
    "black": "Black",
    "blocked": "Blocked",
    "blockedDomains": "Blocked domains",
    "blockedReasons": "Blocked reasons",
    "body": "Body",
    "botName": "Bot name",
    "breadcrumbs": "Breadcrumbs",
    "browserEngine": "Browser engine",
    "browsers": "Browsers",
    "budgetTokens": "Budget tokens",
    "byChannel": "By channel",
    "cached": "cached",
    "calendarEvent": "Event",
    "changePassword": "Change password",
    "channel": "Channel",
    "channels": "Channels",
    "chat": "Chat",
    "chatCount": "No chats | {n} chat | {n} chats",
    "chatCreatedAgo": "Created",
    "chatOrigin": "Chat origin",
    "chatStatistics": "Statistics",
    "chatTypes": "Conversation type",
    "chatUpdatedAgo": "Last message",
    "chatWidget": "Chat widget",
    "chunks": "Chunks",
    "clear": "Clear",
    "codeEditor": "Code",
    "collapseContext": "Hide context",
    "comment": "Comment",
    "comparison": "Comparison",
    "completeName": "Full name",
    "completedAt": "Completed at",
    "configMcpServer": "Configure MCP server",
    "configure": "Configure",
    "confirm": "Confirm",
    "confirmPassword": "Confirm password",
    "confirmPrivateNetwork": "I confirm the endpoint cannot be reached from the internet",
    "confirmWithEmail": "Type your email to confirm",
    "confirmWithPassword": "Enter your password to confirm",
    "connectMcpServer": "Connect MCP server",
    "connectSubAgent": "Connect sub-agent",
    "connectedAccounts": "Connected accounts",
    "connectedIntegrations": "Connected integrations",
    "cssSelector": "CSS selector",
    "hostToolName": "Tool name",
    "hostTools": "Tools of the embedding app",
    "hostToolsAllowed": "Allowed tools",
    "hostToolsConfirmDestructive": "Confirm tools that change data",
    "hostToolsEnabled": "Accept the app's tools",
    "hostToolsLabel": "App name",
    "hostToolsMaxCallsPerTurn": "Calls per answer",
    "hostToolsRequireConfirmation": "Always ask first",
    "hostToolsTimeout": "Maximum wait (seconds)",
    "mcpConnectionSignedIn": "Signed in",
    "mcpConnectionRenewed": "Last renewed",
    "connectionChecking": "Connection checking…",
    "connectionConnected": "Connected",
    "connectionError": "Connection error",
    "connectionIdle": "Not verified",
    "connectionStatus": "Connection",
    "connectionTypes": "Connection type",
    "const": "Constant",
    "contactUs": "Contact us",
    "content": "Content",
    "contentPreview": "Content preview",
    "contextTokens": "{count}k context",
    "conversationLengthBuckets": "Conversation length",
    "conversationOutline": "Conversation outline",
    "conversations": "Conversations",
    "conversationsOverTime": "Conversations over time",
    "cost": "Cost",
    "costByChannel": "Cost per channel",
    "costInUSD": "Cost in USD",
    "costSource": "Cost source",
    "costSourceAll": "Total",
    "costSourceEndpoint": "Endpoint",
    "costSourceGateway": "Gateway",
    "country": "Country",
    "crawlMode": "Crawl mode",
    "createdAt": "Created at",
    "createdBy": "Created by",
    "credit": "Credit",
    "creditUpdatedAt": "Credit updated at",
    "credits": "Credits",
    "crmSync": "CRM sync",
    "curlExample": "cURL example",
    "currentAgent": "Current agent",
    "currentLocation": "Current location",
    "currentPassword": "Current password",
    "currentSession": "Current session",
    "customCss": "Custom CSS",
    "customRange": "Custom range",
    "dailyUsage": "Daily usage",
    "dark": "Dark",
    "darkModePreference": "Dark mode",
    "dataLoadFailed": "Could not load this data",
    "day": "Day",
    "dayRateLimit": "Day rate limit",
    "days": "{count} day | {count} days",
    "default": "Default",
    "defaultMappingHint": "If no mapping is configured, the default one for the provider will be used.",
    "defaultRole": "Default role",
    "deleted": "Deleted",
    "deprecated": "Deprecated",
    "description": "Description",
    "deselectAction": "Remove",
    "details": "Details",
    "device": "Device",
    "deviceContext": "Device context",
    "deviceType": "Device type",
    "diagram": "Diagram",
    "disabled": "Disabled",
    "disallowPromptTraining": "Prompt training disallowed",
    "dismissableNotice": "Notice",
    "documentOrigin": "Origin",
    "documentPriority": "Document priority",
    "documentRefresh": "Automatic update",
    "documentRefreshAuto": "Automatic",
    "documentRefreshInterval": "Frequency",
    "documentRefreshLastRead": "Last read",
    "documentRefreshNext": "Next update",
    "documentRefreshOutcome": "Outcome",
    "documentRefreshPaused": "Paused",
    "documentSourceInterval": "Check frequency",
    "documentSourceLastRun": "Last run",
    "documentSourceLastSync": "Last check",
    "documentSourceNextSync": "Next check",
    "documentSourceSearch": "Search a site",
    "documentType": "Document type",
    "documents": "Documents",
    "domainFilter": "Domain filter",
    "downloadFile": "Download file",
    "downloading": "Downloading",
    "editApiTool": "Edit API tool",
    "editIntegration": "Edit integration",
    "editMcpServer": "Edit MCP server",
    "editSubAgent": "Edit sub-agent",
    "effectiveCredit": "Effective credit",
    "email": "Email",
    "emailClaim": "Email claim",
    "emailDomain": "Email domain",
    "emailVerified": "Email verified",
    "embed": "Embed",
    "embedCode": "Embed code",
    "embedding": "Embedding",
    "embeddingEndpointModel": "Id on the endpoint",
    "embeddingModel": "Embedding model",
    "embeddingModelsCount": "Embedding models ({count})",
    "embeddingNotConfigured": "Not configured",
    "embeddingNotConfiguredReason": "The platform AI gateway is off for this organization",
    "embeddingOnEndpoint": "Embedding on your endpoint",
    "embeddingOnPlatform": "On the platform AI gateway",
    "embeddingReindex": "Reindex of the knowledge base and the memories",
    "embeddingReindexDone": "Reindexed on {date}",
    "embeddingReindexPaused": "Reindex paused",
    "embeddingReindexProgress": "Reindexing: {done} of {total} vectors done",
    "embeddingReindexQueued": "Reindex queued: it starts within a few minutes",
    "enabled": "Enabled",
    "enabledTools": "Enabled tools",
    "endDate": "End date",
    "endpointCost": "Endpoint cost (estimate)",
    "endpointModels": "Your endpoint's models",
    "engagement": "Engagement",
    "enum": "Enum values",
    "error": "Error",
    "estimatedCost": "Estimated end-of-month cost",
    "estimatedCredit": "Estimated credit",
    "estimatedMonthlyCost": "Month-end estimate",
    "excludeDomains": "Exclude domains",
    "expandContext": "Show more context",
    "expireIn": "Expires in",
    "expires": "Expires",
    "expiresAt": "Expiration",
    "exportMyData": "Export my data",
    "externalAuth": "External authentication",
    "externalAuthDescription": "Users sign in with JWT tokens issued by these external providers.",
    "externalAuthInfo": "Whoever signs in this way joins your organization with the default role (auto provisioning).",
    "externalContext": "External context",
    "externalContextSchema": "External context schema",
    "externalId": "External ID (CRM)",
    "fallbackModels": "Fallback models",
    "feedback": "Feedback",
    "feedbacks": "Feedback",
    "fieldMappingFallback": "Fallback value",
    "fieldMappingSource": "Source field",
    "fieldMappingTarget": "Target field {number}",
    "fieldMappingTransform": "Transform",
    "fieldMappingTransformExtractDomainCompany": "Extract company from email domain",
    "fieldMappingTransformJoinArray": "Join array",
    "fieldMappingTransformMapValues": "Map values",
    "fieldMappingTransformNone": "None",
    "fieldMappingTransformSplitFirstLast": "Split first/last",
    "fieldMappingValueMap": "Value map",
    "file": "File",
    "fileUpload": "File upload",
    "fileUploadAllowedMimeTypes": "Allowed file types",
    "fileUploadEnabled": "Enable file upload",
    "fileUploadMaxFileSize": "Max file size (MB)",
    "fileUploadMaxFilesPerChat": "Max files per chat",
    "fileUploadMaxFilesPerMessage": "Max files per message",
    "files": "Files",
    "filters": "Filters",
    "floatingButtonPosition": "Side",
    "folderName": "Folder name",
    "followExternal": "Follow external links",
    "footer": "Footer",
    "forceOcr": "Force OCR",
    "formMaxOptionsPerStep": "Suggested max options",
    "formMaxSteps": "Suggested max steps",
    "frequencyPenalty": "Frequency penalty",
    "freshnessBoost": "Freshness boost",
    "freshnessScale": "Freshness scale",
    "freshnessWeight": "Freshness weight",
    "fullDuration": "Duration (ms)",
    "gallery": "Gallery ({count} images)",
    "gatewayCost": "Gateway cost",
    "gatewayModels": "Platform models",
    "gdprRequestType": {
      "conversations_erasure": "Conversations erasure",
      "erasure": "Data erasure",
      "export": "Data export",
      "organization_erasure": "Data erasure for one organization"
    },
    "gdprRequests": "GDPR requests",
    "general": "General",
    "generateSchemaFromJson": "Generate schema from JSON",
    "glowSecondColor": "Second color",
    "glowSecondColorCustom": "Custom second color",
    "glowToneOne": "One tone",
    "glowToneTwo": "Two tones",
    "glowTones": "Empty chat glow",
    "goalOutcome": "Goal outcome",
    "granularity": "Granularity",
    "greeting": "Greeting",
    "groupReasoningAgents": "Group",
    "hasRedundantChunks": "Has redundant chunks",
    "header": "Header",
    "headers": "HTTP headers",
    "healthCheckPath": "Health check",
    "hour": "Hour",
    "hourRateLimit": "Hour rate limit",
    "hsAccessToken": "Access token",
    "hsAccessTokenHint": "Create a HubSpot Private App with the following scopes: crm.objects.contacts.read, crm.objects.contacts.write, crm.objects.owners.read.",
    "hsDefaultOwnerId": "Default owner ID",
    "hsDefaultOwnerIdHint": "Empty: contacts get no owner.",
    "hsStaticProperties": "Static properties",
    "hsStaticPropertiesHint": "Fixed properties added to every contact.",
    "httpHeaderKey": "Key",
    "httpHeaderValue": "Value",
    "pageAccess": "Page access",
    "pageAccessConfirmEveryAction": "Confirm every action",
    "pageAccessExcludeSelectors": "Excluded areas",
    "pageAccessLevel": {
      "forms": "Annotated forms",
      "full": "Page control",
      "off": "Off",
      "read": "Read"
    },
    "pageAccessNotice": "Notice to the user",
    "pageAccessPointer": "Point and ask",
    "pageAccessRisk": "What this level means",
    "secretParameters": "Secret parameters",
    "secretParameterPosition": "Sent in",
    "secretPositionQuery": "Query string",
    "secretPositionBody": "Body",
    "apiToolCredentialBadge": "Key exposed",
    "httpHeaders": "HTTP headers",
    "iframe": "Iframe",
    "iframeCode": "Iframe code",
    "imageLoadError": "Image not available",
    "imageHeld": "Image from {host}: click to load",
    "videoHeld": "Video from {host}: click to load",
    "imageHost": "Host",
    "imageHosts": "Image hosts",
    "imageHostsHint": "Answers and cards load images by themselves only from these hosts and from the platform.",
    "imageHostsInfo": "An image from any other host shows its host and loads on a click, so an answer cannot send the conversation to a site through an image url.",
    "impersonated": "Impersonated",
    "impersonation": "Impersonation",
    "importing": "Importing",
    "inStock": "In stock",
    "integrationReconnectNeeded": "Reconnect needed",
    "integrationAppCredential": "App {clientId}",
    "modelDefaults": "Default models",
    "modelNotAvailable": "not available",
    "modelSourcePlatform": "Platform",
    "modelSwitchedOff": "switched off",
    "ownEndpoint": "Your own endpoint (BYOK)",
    "price": "Price",
    "priceListModel": "Price list model",
    "priceToSet": "Price to set",
    "modelPriceOf": "Price of {id}",
    "context": "Context",
    "someProviders": "Some providers",
    "modelsActiveSummary": "{active} of {count} models active",
    "noModelsYet": "No models yet",
    "notServedAnyMore": "No longer offered by the endpoint",
    "modelIdByHand": "Model id",
    "modelReference": "Reference model",
    "msClientId": "Application (client) ID",
    "msClientSecret": "Client secret",
    "msTenantId": "Directory (tenant) ID",
    "inTest": "In testing",
    "includeDomains": "Include domains",
    "includeThoughts": "View reasoning",
    "indexStatus": "Index status",
    "info": "Info",
    "initialMessage": "Initial message",
    "input": "Input",
    "inputSchema": "Input schema",
    "insertEmail": "Insert email",
    "integration": "Integration",
    "integrationConfig": "Configuration",
    "integrationDisabled": "Disabled",
    "integrationEnabled": "Enabled",
    "integrationFieldMapping": "Field mapping",
    "integrationProvider": "Provider",
    "integrationSyncLogs": "Sync logs",
    "integrationSyncLogsDescription": "Synchronization occurs automatically when a new lead is created.",
    "integrations": "Integrations",
    "interactiveLogin": "Show login/registration",
    "interface": "Interface",
    "ipAddress": "IP address",
    "isAutoJoinEnabled": "Automatically merge existing users with the same email",
    "issuer": "Issuer",
    "itemsPerPage": "Per page",
    "jsonSample": "JSON sample",
    "jwksUrl": "JWKS URL",
    "key": "Key",
    "keyboardShortcuts": "Keyboard shortcuts",
    "language": "Language",
    "languages": "Languages",
    "last14Days": "Last 14 days",
    "last30Days": "Last 30 days",
    "last7Days": "Last 7 days",
    "last90Days": "Last 90 days",
    "lastActive": "Last active",
    "lastActivity": "Last activity",
    "lastMonth": "Last month",
    "lastRecalledAt": "Last recalled",
    "lastReconciledAt": "Last reconciled at",
    "lastRefillAt": "Last refill at",
    "lastSync": "Last sync",
    "lastUsedAt": "Last used",
    "latest": "Latest",
    "leadId": "Lead ID",
    "left": "Left",
    "light": "Light",
    "limit": "Limit",
    "limitedStock": "Limited stock",
    "linkedAgents": "Linked agents",
    "llmIssues": "LLM issues",
    "loadDelay": "Load delay (ms)",
    "loaderStrategy": "Loader strategy",
    "loaderStrategyDynamicImport": "Dynamic import",
    "loaderStrategyInlineModule": "Inline module",
    "loaderStrategyScriptSrc": "Script src",
    "locale": "Language",
    "location": "Location",
    "logo": "Logo",
    "logoUrl": "Logo URL",
    "mainColor": "Main color",
    "manageProfileDescription": "Edit your name, password, avatar and more",
    "maxDepth": "Max depth",
    "maxMessageLength": "Max message length",
    "maxOutputTokens": "Max tokens",
    "maxPages": "Max pages",
    "maxResults": "Max results",
    "maxStepCount": "Max steps",
    "maxUses": "Max uses",
    "mcpAuthType": "Authentication type",
    "mcpServer": "MCP server",
    "mcpServerUrl": "MCP server URL",
    "mcpStatelessServer": "Stateless client",
    "memberSince": "Member since",
    "memories": "Memories",
    "memory": "Memory",
    "message": "Message",
    "messageDetails": "Message detail",
    "messageNumber": "Message {n}",
    "messagePlaceholder": "Placeholder",
    "messages": "Messages",
    "metadata": "Metadata",
    "method": "Method",
    "mimeTypeAudio": "Audio",
    "mimeTypeCode": "Code",
    "mimeTypeImages": "Images",
    "mimeTypePdf": "PDF",
    "mimeTypeSpreadsheets": "Excel spreadsheets",
    "mimeTypeText": "Text",
    "mimeTypeWordDocuments": "Word documents",
    "minuteRateLimit": "Minute rate limit",
    "mmr": "Maximal marginal relevance (MMR)",
    "mmrCandidatesLimit": "Candidates limit",
    "mmrDiversity": "MMR diversity",
    "model": "Model",
    "modelParameters": "Model parameters",
    "month": "Month",
    "monthRateLimit": "Month rate limit",
    "monthlyCost": "Monthly cost",
    "multipleChoiceAllowCustomAnswer": "Allow custom answer",
    "multipleChoiceMaxOptions": "Maximum number of options",
    "name": "Name",
    "nameClaim": "Name claim",
    "never": "Never",
    "newChat": "New chat",
    "newPassword": "New password",
    "no": "No",
    "noDataAvailable": "No data available",
    "noDataRetention": "ZDR",
    "noFieldMapping": "No custom field mapping configured",
    "noIntegrations": "No integrations configured",
    "noPromptTraining": "No training",
    "noSyncLogs": "No sync logs found",
    "noTimingData": "No data yet. Make a chat request to see timing logs.",
    "notAvailable": "Not available",
    "notCompatible": "not compatible",
    "notConfigured": "Not configured",
    "notConnected": "Not connected",
    "notSynced": "Not synced",
    "notificationTitle": {
      "document_error": "Document processing failed",
      "document_sync_removed": "Documents removed from a synchronised folder",
      "headless_quota_exceeded": "Daily automation quota reached",
      "organization": {
        "created": "Organization created",
        "deleted": "Organization deleted",
        "invite": "Organization invite",
        "invite_accepted": "Invitation accepted",
        "invite_rejected": "Invitation rejected",
        "removed": "Removed from organization"
      },
      "password_reset_requested": "A password reset has been requested",
      "two_factor": {
        "enabled": "Two-step verification turned on",
        "disabled": "Two-step verification turned off",
        "app": "Two-step verification uses an app",
        "reset": "Two-step verification reset",
        "passkeyAdded": "Passkey added",
        "passkeyRemoved": "Passkey removed",
        "unlocked": "Two-step verification unlocked",
        "passkeyRemovedByAdmin": "Passkey removed by an administrator",
        "trustedDevicesForgotten": "Trusted devices forgotten"
      },
      "web_source_pages_removed": "Pages removed because they left the sitemap",
      "web_source_removal_held": "Pages that left a sitemap were not removed",
      "mcp_connection_revoked": "{serverName} disconnected by an administrator",
      "platform_account_linked": "WhatsApp number linked",
      "chat_warning": {
        "warning": "Conversation warning",
        "blocked": "Conversation blocked"
      },
      "chat_blocked": {
        "warning": "Conversation warning",
        "blocked": "Conversation blocked"
      }
    },
    "notificationType": {
      "agent_wakeup": "Agent check",
      "api_key_expiring": "API Key expiring",
      "chat_blocked": "Chat blocked",
      "chat_warning": "Chat warning",
      "document_error": "Document error",
      "document_sync_removed": "Synchronised content removed",
      "generic": "Generic",
      "headless_quota_exceeded": "Automation quota",
      "organization": "Organization",
      "password_reset_requested": "Password reset requested",
      "two_factor": "Sign-in security",
      "web_source_pages_removed": "Pages that left a sitemap",
      "web_source_removal_held": "Removal to confirm"
    },
    "oauthAuthorizationUrl": "OAuth authorization URL",
    "oauthClientId": "OAuth client ID",
    "oauthClientSecret": "OAuth client secret",
    "oauthScopes": "OAuth scopes",
    "oauthTokenUrl": "OAuth token URL",
    "ocrUsed": "OCR",
    "older": "Older",
    "onChannels": "WA · Teams",
    "openSource": "Open source",
    "operatingSystems": "Operating systems",
    "or": "Or",
    "organization": "Organization",
    "organizations": "Organizations",
    "origin": "Origine",
    "originalMessage": "Original answer",
    "origins": "Origins",
    "outOfStock": "Out of stock",
    "output": "Output",
    "outputSchema": "Output schema",
    "pages": "Pages",
    "passphrase": "Enter passphrase",
    "password": "Password",
    "paused": "Paused",
    "peakHours": "Peak hours",
    "perMillionTokens": "per million tokens",
    "period": "Period",
    "phone": "Phone number",
    "picture": "Picture",
    "platformAssistant": "Platform assistant",
    "platformContext": "Platform context",
    "preferences": "Preferences",
    "presencePenalty": "Presence penalty",
    "preview": "Preview",
    "priceInput": "Input price",
    "priceOutput": "Output price",
    "priority": "Priority",
    "priority_1": "Lowest",
    "priority_2": "Low",
    "priority_3": "Normal",
    "priority_4": "High",
    "priority_5": "Critical",
    "privacy": "Privacy",
    "privacyPolicyNotice": "Privacy notice",
    "processedAt": "Processed at",
    "processing": "Processing…",
    "profile": "Profile",
    "prompt": "Prompt",
    "properties": "Properties",
    "provider": "Provider",
    "providerOrganizationId": "Provider ID",
    "providerTimeoutMs": "Provider timeout (ms)",
    "qdrantSync": "Vector sync",
    "qrCode": "QR code",
    "question": "Question",
    "rateLimits": "Rate limits",
    "read": "Read",
    "reasoning": "Reasoning",
    "reasoningAgentTester": "Reasoning agent tester",
    "reasoningDetails": "Reasoning details",
    "reasoningEffort": "Reasoning effort",
    "reasoningSummary": "Reasoning summary",
    "recommended": "Recommended",
    "redundantChunks": "Redundant chunks",
    "referrerDomains": "Referrer domains",
    "refillAmount": "Refill amount",
    "released": "Released",
    "rememberMe": "Remember me",
    "replyWithoutText": "Reply without text",
    "requestCount": "Requests",
    "requestedAt": "Requested at",
    "requests": "Requests",
    "requestsPerAgent": "Requests per agent",
    "requestsUsed": "Requests used",
    "required": "Required",
    "requiredFields": "Required fields",
    "retired": "retired",
    "revisedMessage": "Revised answer",
    "right": "Right",
    "riskScoreBands": "Risk score bands",
    "role": "Role",
    "platformRole": "Platform role",
    "rootDocuments": "Without folder",
    "scheduledAt": "Scheduled at",
    "schemaRootArray": "Array",
    "schemaRootObject": "Object",
    "schemas": "Schemas",
    "screenCategories": "Screen resolution",
    "searchAndExecution": "Search & execution",
    "searchMode": "Search mode",
    "searchRecencyFilter": "Recency filter",
    "sectionChannelBreakdown": "Channel breakdown",
    "sectionConversationQuality": "Conversation quality",
    "sectionCostTrend": "Monthly cost trend",
    "sectionDeviceContext": "Devices & context (web and widget)",
    "sectionTraffic": "Traffic (web and widget)",
    "security": "Security",
    "selectAgent": "Select an agent",
    "selectedHint": "Selected",
    "sentiment": "Sentiment",
    "sentimentTrends": "Sentiment trends",
    "serverInfo": "MCP Server info",
    "sessionExpiresIn": "Session duration (seconds)",
    "setPassword": "Set password",
    "settings": "Settings",
    "sfApiVersion": "API version",
    "sfClientId": "Client ID",
    "sfClientSecret": "Client secret",
    "sfExternalIdField": "External ID field",
    "sfInstanceUrl": "Instance URL",
    "shareWith": "Share with agents",
    "showExtendedSteps": "Extended steps view",
    "showReasoning": "Show reasoning",
    "similarity": "Similarity",
    "siteAndApp": "Site and app",
    "sitemapUrl": "Sitemap URL",
    "size": "Size",
    "slug": "Slug",
    "smartRanking": "Smart ranking",
    "smoothStream": "Smooth streaming",
    "sortAscending": "Ascending order",
    "sortBy": "Sort by",
    "sortDescending": "Descending order",
    "source": "Source",
    "sources": "Sources",
    "spokenExchange": "Exchanged by voice",
    "startDate": "Start date",
    "startUrl": "Start URL",
    "status": "Status",
    "style": "Style",
    "subAgent": "Sub-agent",
    "subject": "Subject",
    "syncStatus": "Sync status",
    "targetAll": "All users",
    "targetOrganization": "Organization",
    "targetType": "Target",
    "targetUser": "Specific user",
    "teams": "Microsoft Teams",
    "teamsAccentColor": "Accent color",
    "teamsAppId": "App ID (Microsoft)",
    "teamsAppPassword": "App password / client secret",
    "teamsAppTenantId": "Tenant ID",
    "teamsAppType": "App type",
    "teamsAppVersion": "App version",
    "teamsDescriptionFull": "Full description",
    "teamsDescriptionShort": "Short description",
    "teamsDeveloperName": "Developer name",
    "teamsManifestDetails": "App details (shown in Teams)",
    "temperature": "Temperature",
    "testConnection": "Test connection",
    "testPlayground": "Test playground",
    "textColor": "Text color",
    "theme": "Theme",
    "thinking": "Thinking",
    "thinkingBudget": "Thinking budget",
    "thinkingDisplay": "Thinking display",
    "thinkingEffort": "Thinking effort",
    "thinkingLevel": "Thinking level",
    "thinkingType": "Thinking type",
    "thisMonth": "This month",
    "timeoutMs": "Timeout (ms)",
    "timezoneRegions": "Timezone region",
    "title": "Title",
    "today": "Today",
    "tokens": "tokens",
    "tool": "Tool",
    "toolApprovalBadge": "User confirm",
    "toolName": "Tool name: {name}",
    "toolRequiresApproval": "Ask the user to confirm",
    "toolWorkingSet": "Tool selection",
    "toolWorkingSetMode": "Mode",
    "tools": "Tools",
    "topPages": "Top pages",
    "topTopics": "Top topics",
    "total": "Total",
    "totalConversations": "Chat in total",
    "totalCost": "Total cost",
    "totalCostPartlyEstimated": "Total cost, partly estimated",
    "totalItemsCount": "Items: {total}",
    "totalMessages": "Messages in total",
    "totalPages": "of {total}",
    "trustedOrigins": "Trusted origins",
    "tuning": "Tuning",
    "type": "Type",
    "uniqueUsers": "Unique users",
    "unitChat": "chats",
    "unitChatPerUser": "chats",
    "unitMessages": "messages",
    "unitMessagesPerChat": "messages",
    "unitUsers": "users",
    "unknown": "Unknown",
    "unread": "Unread",
    "updateProfile": "Update profile",
    "updatedAt": "Updated at",
    "upload": "Upload {index}/{total}",
    "url": "Web page URL",
    "usage": "Usage",
    "useBrowserEngine": "Browser engine",
    "useExtractionStrategy": "Use AI",
    "user": "User",
    "userInput": "Selected option",
    "userQuestion": "Question",
    "userTones": "User tone",
    "users": "Users",
    "utilityModel": "Model for internal tasks",
    "value": "Value",
    "version": "Version",
    "video": "Video",
    "viewPdfPage": "View PDF page",
    "visibility": "Visibility",
    "visualEditor": "Visual",
    "voice": "Voice",
    "voiceCascadeTimeoutSeconds": "Answer deadline (seconds)",
    "voiceEnabled": "Voice conversation",
    "voiceFillerAfterSeconds": "Filler after (seconds)",
    "voiceFillerMessage": "Filler phrase",
    "voiceFirstMessage": "Opening line",
    "voiceId": "Voice",
    "voiceIgnoreBackgroundVoices": "Ignore background voices",
    "voiceLanguage": "Spoken language",
    "voiceMaxSessionSeconds": "Session limit (seconds)",
    "voiceTurnEagerness": "End of turn",
    "voiceTurnTimeoutSeconds": "Pause before speaking again (seconds)",
    "vote": "Vote",
    "warnings": "Warnings",
    "webSearch": "Web search",
    "webSearchEnabled": "Enable web search",
    "webSearchNative": "Built-in",
    "webSearchProvider": "Search provider",
    "webhookUrl": "Webhook URL",
    "week": "Week",
    "welcome": "Welcome to {appName}!",
    "whatsapp": "WhatsApp",
    "whatsappAccessToken": "Access token",
    "whatsappAppSecret": "App secret",
    "whatsappPhoneNumberId": "Phone number ID",
    "whatsappVerifyToken": "Verify token",
    "white": "White",
    "widgetAppearance": "Appearance",
    "widgetAppearanceSolid": "Solid",
    "widgetAppearanceGlass": "Glass",
    "hideFloatingButton": "Hide the open button",
    "copilotPageCss": "Page CSS",
    "widgetLayout": "Layout",
    "widgetLayoutCopilot": "Copilot",
    "widgetLayoutFloating": "Floating",
    "widgetUrl": "Widget URL",
    "workingGlow": "Glow while working",
    "year": "Year",
    "yes": "Yes",
    "yesterday": "Yesterday",
    "zeroDataRetention": "Zero data retention (ZDR)",
    "webPagesRefresh": "How often to read the pages again",
    "webSourceWatch": "Also look for new pages",
    "webSourceInterval": "How often to look for them",
    "webSourceRemoveMissing": "Remove pages that leave the sitemap",
    "apiUrl": "API URL",
    "createEndpoint": "Create endpoint",
    "wakeupCheck": "Automatic check",
    "wakeupNext": "Next check at {time}",
    "wakeupQuietRun": "Nothing new at the {time} check | Nothing new in {count} checks, the last at {time}",
    "notificationBody": {
      "document_error": "One or more documents failed to process.",
      "document_sync_removed": {
        "one": "“{documentName}” is no longer in the synchronised folder and has been removed from the knowledge base.",
        "many": "{count} documents are no longer in the synchronised folder and have been removed from the knowledge base."
      },
      "web_source_pages_removed": {
        "one": "“{documentName}” is no longer listed in the sitemap and has been removed from the knowledge base.",
        "many": "{count} pages are no longer listed in the sitemap and have been removed from the knowledge base."
      },
      "web_source_removal_held": "{count} pages are no longer listed in the sitemap, too many at once to remove without a check. Nothing was removed: open the source to review and remove them.",
      "headless_quota_exceeded": "The organization started {quota} automatic runs today, its daily quota: the agents' repeated checks are skipped until tomorrow.",
      "mcp_connection_revoked": "An administrator ended your sign-in to {serverName}, and the agents no longer use that account. If you need it again, the agent will ask you to sign in.",
      "platform_account_linked": "The WhatsApp number {phone} now uses your account, your integrations included. If this was not you, unlink it from Profile, Integrations.",
      "password_reset_requested": "A password reset was requested for your account. If this was not you, secure your account right away.",
      "organization": {
        "created": "Your organization “{organizationName}” has been created.",
        "deleted": "The deletion of {organizationName} is complete.",
        "invite": "{inviterName} invited you to join {organizationName}.",
        "invite_accepted": "{inviteeName} accepted your invitation to join {organizationName}.",
        "invite_rejected": "{inviteeName} declined your invitation to join {organizationName}.",
        "removed": "You are no longer a member of {organizationName}."
      },
      "two_factor": {
        "enabled": "Signing in with your password now also asks for a code. If this was not you, reset your password right away.",
        "disabled": "Signing in with your password no longer asks for a code. If this was not you, change your password and turn it back on.",
        "app": "An authenticator app now gives the codes, and codes by email are no longer accepted. If this was not you, reset your password right away.",
        "reset": "An administrator reset your two-step verification and your passkeys, and signed you out everywhere. Set them up again from your profile.",
        "passkeyAdded": "A new passkey signs in to your account without the password and without a code. If this was not you, remove it from your profile and reset your password right away.",
        "passkeyRemoved": "A passkey no longer signs in to your account. If this was not you, change your password.",
        "unlocked": "An administrator lifted the pause that followed too many wrong codes. If you did not ask for this, change your password.",
        "passkeyRemovedByAdmin": "An administrator removed a passkey from your account. Your other passkeys and your two-step verification are unchanged.",
        "trustedDevicesForgotten": "An administrator made your account forget the devices that skipped the code: the next sign-in on each asks for one."
      },
      "chat_warning": {
        "warning": "A conversation received a warning. Risk score: {riskScore}.",
        "blocked": "A conversation has been automatically blocked. Risk score: {riskScore}."
      },
      "chat_blocked": {
        "warning": "A conversation received a warning. Risk score: {riskScore}.",
        "blocked": "A conversation has been automatically blocked. Risk score: {riskScore}."
      },
      "agent_wakeup": "Checked again and has news for you in your conversation."
    },
    "invitationLanguage": "Invitation language"
  },
  "language": {
    "de": "German",
    "en": "English",
    "english": "English",
    "es": "Spanish",
    "fr": "French",
    "french": "French",
    "german": "German",
    "it": "Italian",
    "italian": "Italian",
    "nl": "Dutch",
    "pt": "Portuguese",
    "spanish": "Spanish"
  },
  "lead": {
    "contactReason": {
      "appointment": "Appointment",
      "callback_request": "Callback request",
      "complaint": "Complaint",
      "info_request": "Information request",
      "other": "Other",
      "quote_request": "Quote request",
      "support": "Support"
    },
    "label": {
      "budget": "Budget",
      "company": "Company",
      "contactReason": "Contact reason",
      "conversationSummary": "Conversation summary",
      "preferredContactMethod": "Preferred contact method",
      "preferredContactTime": "Preferred contact time",
      "productInterest": "Product interest",
      "sentiment": "Sentiment",
      "topics": "Topics",
      "urgency": "Urgency"
    },
    "preferredContactMethod": {
      "any": "Any",
      "email": "Email",
      "phone": "Phone",
      "whatsapp": "WhatsApp"
    },
    "preferredContactTime": {
      "afternoon": "Afternoon",
      "any": "Any",
      "evening": "Evening",
      "morning": "Morning"
    },
    "sentiment": {
      "excited": "Excited",
      "frustrated": "Frustrated",
      "negative": "Negative",
      "neutral": "Neutral",
      "positive": "Positive"
    },
    "urgency": {
      "high": "High",
      "low": "Low",
      "medium": "Medium"
    }
  },
  "mcpAuthType": {
    "externalToken": "External authentication token per user",
    "headers": "HTTP headers (API key)",
    "oauth": "OAuth 2.0 per user"
  },
  "mcpConnectionStatus": {
    "active": "In use",
    "orphan": "Unused",
    "stale": "Expired"
  },
  "markdownEditor": {
    "toolbarTips": {
      "bold": "Bold",
      "underline": "Underline",
      "italic": "Italic",
      "strikeThrough": "Strikethrough",
      "title": "Heading",
      "sub": "Subscript",
      "sup": "Superscript",
      "quote": "Quote",
      "unorderedList": "Bulleted list",
      "orderedList": "Numbered list",
      "task": "Task list",
      "codeRow": "Inline code",
      "code": "Code block",
      "link": "Link",
      "image": "Image",
      "table": "Table",
      "mermaid": "Mermaid diagram",
      "katex": "Formula",
      "revoke": "Undo",
      "next": "Redo",
      "save": "Save",
      "prettier": "Format",
      "pageFullscreen": "Full screen in the page",
      "fullscreen": "Full screen",
      "preview": "Preview",
      "previewOnly": "Preview only",
      "htmlPreview": "HTML preview",
      "catalog": "Contents",
      "github": "Source code"
    },
    "titleItem": {
      "h1": "Heading 1",
      "h2": "Heading 2",
      "h3": "Heading 3",
      "h4": "Heading 4",
      "h5": "Heading 5",
      "h6": "Heading 6"
    },
    "imgTitleItem": {
      "link": "Add an image link",
      "upload": "Upload images",
      "clip2upload": "Crop and upload"
    },
    "linkModalTips": {
      "linkTitle": "Add link",
      "imageTitle": "Add image",
      "descLabel": "Description:",
      "descLabelPlaceHolder": "Enter a description…",
      "urlLabel": "Link:",
      "urlLabelPlaceHolder": "Enter a link…",
      "buttonOK": "OK"
    },
    "clipModalTips": {
      "title": "Crop image",
      "buttonUpload": "Upload"
    },
    "copyCode": {
      "text": "Copy",
      "successTips": "Copied",
      "failTips": "Copy failed"
    },
    "mermaid": {
      "flow": "Flowchart",
      "sequence": "Sequence",
      "gantt": "Gantt",
      "class": "Class",
      "state": "State",
      "pie": "Pie",
      "relationship": "Relationship",
      "journey": "Journey"
    },
    "katex": {
      "inline": "Inline",
      "block": "Block"
    },
    "footer": {
      "markdownTotal": "Characters",
      "scrollAuto": "Synced scrolling"
    }
  },
  "mcpServerStatus": {
    "active": "Active",
    "error": "Error",
    "inactive": "Inactive"
  },
  "member": {
    "agentAccess": {
      "limited": "Only the selected agents",
      "privateAgents": "Private agents",
      "hintAll": "The member uses every organization agent, including those created later, and only the selected Private agents.",
      "hintLimited": "The member uses only the selected agents. With none selected, they use no agent of the organization.",
      "managerHint": "Owners and admins can use every agent; their access cannot be restricted.",
      "column": "Agents",
      "all": "All",
      "allPlusPrivate": "All + {n} private",
      "allPlusPrivateTitle": "Uses every organization agent and these Private agents: {names}",
      "count": "{n} agent | {n} agents",
      "none": "None",
      "allTitle": "Can use every organization agent",
      "managerTitle": "Owners and admins use every agent",
      "noneTitle": "No agent enabled: none is, or those were deleted or opened to everyone",
      "readError": "The agents of this member could not be read: close the dialog and try again."
    }
  },
  "memorySource": {
    "explicit": "Explicit | Explicit",
    "extracted": "Extracted | Extracted"
  },
  "message": {
    "accountLinkAlreadyLinked": "This account is already linked to another user. Sign in with that user to unlink it first.",
    "accountLinkCancelled": "Linking was cancelled on the provider's page. Nothing was changed.",
    "accountLinkEmailMismatch": "You can only link accounts that use the same email as your profile.",
    "accountLinkErrorWithCode": "Unable to link the account (code: {code}). Try again or contact support with this code.",
    "accountLinkNotAllowed": "This provider cannot be linked to your profile: the account's email is not verified or linking is disabled.",
    "accountLinkUserInfo": "The provider did not return a usable profile, so no account was linked. Try again.",
    "accountUnlinked": "Account disconnected",
    "agentAccessDenied": "You do not have access to this agent",
    "agentAccessDeniedAction": "View available agents",
    "agentActivated": "Agent activated successfully",
    "agentDeactivated": "Agent deactivated successfully",
    "agentNotFound": "Agent not found",
    "agentsEmpty": "No agents yet. Create the first one to get started.",
    "analyzeChatError": "The analysis did not complete. Try again in a few minutes.",
    "analyzeChatInProgress": "Analyzing the conversation. A long conversation can take about a minute.",
    "analyzeChatSuccess": "Conversation analyzed successfully",
    "apiKeyCreatedForUser": "Shown only once: copy it and pass it on securely.",
    "apiKeysEmpty": "The keys you create for programmatic access appear here.",
    "apiToolsEmpty": "No API tools yet. Add the first one to let the agent call an external service.",
    "banSuccess": "User banned successfully",
    "blockChatSuccess": "Conversation blocked successfully",
    "bulkUnlinkAllDeleteConfirm": "{count} document(s) will be permanently deleted because they have no other linked agents. Do you want to proceed?",
    "bulkUnlinkMixedConfirm": "{unlinkCount} document(s) will be unlinked and {deleteCount} will be permanently deleted (they have no other linked agents). Do you want to proceed?",
    "cancelInvitationConfirm": "Are you sure you want to cancel the invitation for {email}?",
    "cancelInvitationSuccess": "Invitation cancelled successfully",
    "chatActionError": "The action did not complete. Try again in a few minutes.",
    "chatAnonymized": "The content of this conversation has been erased (GDPR): only aggregate metrics remain.",
    "chatErrorBadRequest": "An error occurred with the request. Start a new chat to continue.",
    "chatErrorContextWindow": "The conversation has become too long. Start a new chat to continue.",
    "chatErrorConversationBlocked": "This conversation has been blocked for policy violations.",
    "backgroundAnswerReady": "The agent answered in “{title}”",
    "backgroundAnswerReadyUntitled": "The agent answered in another conversation",
    "chatErrorCreditExhausted": "Service unavailable. Try again later.",
    "chatErrorGatewayDisabled": "This agent's model is not available: the organization does not use the platform AI gateway. An administrator can move the agent to one of the organization's own models.",
    "chatErrorGatewayPromptTraining": "Model \"{model}\" does not support the \"Disable prompt training\" option. Disable this setting in the agent's gateway configuration or choose a compatible model.",
    "chatErrorGatewayZdr": "Model \"{model}\" does not support the \"Zero Data Retention\" option. Disable ZDR in the agent's gateway configuration or choose a compatible model.",
    "chatErrorGeneric": "An error occurred. Start a new chat if the problem persists. Retrying in {seconds}…",
    "chatErrorInternalServer": "A server error occurred. Start a new chat to continue.",
    "chatErrorModelUnavailable": "This agent's model is not available right now: the endpoint it runs on is switched off or no longer serves it. An administrator can switch it back on or move the agent to another model.",
    "chatErrorNotFound": "The conversation is no longer available. Start a new chat to continue.",
    "chatErrorOriginNotAllowed": "The request origin is not allowed. Contact the system administrator.",
    "chatErrorRateLimit": "The rate limit has been exceeded. Retrying in {seconds} seconds…",
    "chatErrorRetrying": "Retrying in {seconds} seconds…",
    "checkYourEmail": "Check your email inbox",
    "confirm": "Are you sure you want to proceed?",
    "confirmRefillCredits": "Are you sure you want to refill the credit of {amount} €?",
    "contentTruncated": "Content truncated. Total characters: {total}",
    "copied": "Copied to clipboard",
    "crawlError": "Error during crawling",
    "createFolderSuccess": "Folder created successfully",
    "defaultAgentWelcome": "Hello! How can I help you today?",
    "defaultPrivacyPolicyNotice": "By sending the request you accept our [Privacy Policy](https://www.iubenda.com/privacy-policy/46350192).",
    "deleteAgentConfirm": "Its folders are deleted. A document no other agent uses is deleted, a shared one stays with the other agents.",
    "deleteAllMemoriesConfirm": "They go for good, semantic search included.",
    "deleteAllNotificationsConfirm": "Delete every notification?",
    "deleteBulkDocumentConfirm": "They are removed from every agent linked to them and go to the trash, where they can be restored.",
    "deleteDocumentConfirm": "It is removed from every agent linked to it and goes to the trash, where it can be restored.",
    "deleteDocumentConfirmWithAgents": "It goes to the trash, where it can be restored, and is removed from the following agents:{agents}",
    "deleteError": "The deletion failed. Try again.",
    "deleteFolderConfirm": "Its documents are removed from this agent. A document no other agent uses is deleted.",
    "deleteFolderSuccess": "Folder deleted successfully",
    "deleteMyConversationsConfirm": "This cannot be undone.",
    "deleteNotificationConfirm": "Delete this notification?",
    "deleteProfileBlockedSoleOwner": "You are the sole owner of {organizations}. Transfer ownership or delete the organizations before deleting your account.",
    "deleteProfileConfirm": "You are about to permanently delete your account: your profile will be anonymized and the content of your conversations erased. This action cannot be undone.",
    "deleteProfileDescription": "Anonymize your account and erase the content of your conversations (right to be forgotten).",
    "diagramRenderError": "Could not render diagram.",
    "documentRefreshPausedReason": "The page no longer responds, so the automatic update is paused. Update now to try again.",
    "documentRefreshSet": "Automatic update set on {updated} documents, {skipped} skipped because they are not web pages",
    "documentRefreshStarted": "Update started on {queued} documents, {skipped} skipped",
    "documentsEmpty": "Create a document or a folder here. To import from a website or a connected service, use the Create menu.",
    "documentsEmptyManaged": "No synced files in this folder. Its content comes from the connected source: if you have just linked it, the first import can take a few minutes.",
    "documentsNoMatch": "No document matches the search or the filters. Reset them to see everything.",
    "documentSourceLinked": "Folder linked. The first import starts shortly.",
    "documentSourceNothingHere": "Nothing in here.",
    "documentSourceStale": "The state of this folder is not up to date: the last read failed.",
    "documentSourceUnlinked": "Folder unlinked. Its documents stay, and can now be edited like any other.",
    "embeddingActivated": "Embedding saved: the endpoint serves the declared model",
    "embeddingBackToPlatform": "The vectors are computed on the platform again",
    "embeddingIndexNotUpdated": "The progress stopped updating.",
    "embeddingRemoved": "Embedding removed from the endpoint",
    "empty": "No items found",
    "endpointActivated": "Endpoint activated successfully",
    "endpointDeactivated": "Endpoint deactivated successfully",
    "endpointsEmpty": "No endpoints yet. Create the first one to expose the agent over HTTP.",
    "error": "Error",
    "errorRetry": "Something went wrong. Try again.",
    "exportError": "Error while exporting data",
    "exportFailed": "The data export failed. Try again later.",
    "exportMyDataDescription": "Download a complete copy of your personal data as a ZIP archive (GDPR Art. 15 and 20).",
    "exportRequested": "We are preparing your archive: you will receive an email with the download link.",
    "exportSuccess": "CSV exported successfully",
    "feedbackSubmitError": "Submission failed. Try again.",
    "feedbackSubmittedMessage": "Your feedback has been submitted successfully.",
    "feedbackSubmittedTitle": "Thank you!",
    "feedbacksEmpty": "Feedback that users leave on the agent's answers will appear here.",
    "fileAlreadyImported": "Already imported",
    "fileAlreadyImportedExistingList": "The following files are already present in the organization:\n{names}",
    "fileAlreadyImportedLink": "This file has already been imported. Do you want to link the existing document to the current agent or create a new one?",
    "fileAlreadyImportedNewList": "The following files are new and will be imported normally:\n{names}",
    "fileAlreadyImportedQuestion": "Do you want to link the existing files to the current agent?",
    "fileAlreadyLinkedToAgent": "The following files are already linked to the current agent:\n{names}",
    "fileLimitPerChat": "You have reached the limit of {max} files for this conversation.",
    "fileLimitPerMessage": "You can attach at most {max} files per message.",
    "foldersEmpty": "No folders yet. Create the first one from the documents page to organize them.",
    "formRenderError": "The form could not be shown. Ask again and the agent will send it.",
    "gdprRequestsEmpty": "Export or deletion requests for this user appear here.",
    "geolocationPermissionDenied": "Location access denied. Allow it in your browser settings.",
    "geolocationUnavailable": "Location unavailable. Try again or enter your location manually.",
    "getMcpServerInfoError": "The server did not answer with its list of tools. Check that the address is right and that the server is reachable, then try again.",
    "importError": "Error during import",
    "importSuccess": "{count} documents imported successfully",
    "importing": "Importing…",
    "info": "Information",
    "insufficientCredit": "Insufficient credit. Try again later.",
    "insufficientCreditMessage": "Your credit is insufficient to complete this operation. Contact the system administrator for more information.",
    "integrationConnected": "Connected successfully.",
    "integrationCreated": "Integration created successfully",
    "integrationDisabled": "Integration disabled",
    "integrationDisconnected": "Connection removed.",
    "integrationDisconnectConfirm": "The folders it keeps in sync are unlinked.",
    "integrationEnabled": "Integration enabled",
    "integrationOAuthDenied": "The connection was refused, or a Microsoft 365 administrator has not approved it yet.",
    "integrationOAuthFailed": "The connection did not succeed.",
    "integrationOAuthStartFailed": "The connection could not be started.",
    "integrationRemoveConfirm": "This integration's configuration is removed.",
    "integrationTestFailed": "Connection test failed: {error}",
    "integrationTestSuccess": "Connection verified successfully",
    "integrationUpdated": "Integration updated successfully",
    "invalidJson": "The input is not valid JSON",
    "invitationAccepted": "Invitation accepted",
    "invitationAlreadyHandled": "Invitation already handled",
    "invitationDeclined": "Invitation declined",
    "invitationResent": "Invitation sent again to {email}",
    "invitationSent": "Invitation sent to {email}",
    "invitationToJoinOrganization": "You have been invited to join",
    "invitationsEmpty": "No pending invitations. Invite people from the members page.",
    "leadSubmitError": "Failed to submit. Try again.",
    "leadSubmittedMessage": "Your information has been submitted successfully.",
    "leadSubmittedTitle": "Thank you!",
    "leadsEmpty": "Leads collected by the agent during conversations will appear here.",
    "leftOrganization": "You have successfully left the organization",
    "loadConversationsError": "Failed to load conversations",
    "loading": "Loading…",
    "loadingError": "Error while loading",
    "mcpConnectionConnectedAt": "Signed in on {date}",
    "mcpConnectionDisconnectDescription": "The agents will no longer use your {name} account. The next time you need it, the agent will ask you to sign in, and you can choose a different account.",
    "mcpConnectionDisconnectQuestion": "Disconnect {name}?",
    "mcpConnectionDisconnected": "{name} account disconnected",
    "mcpConnectionsDescription": "The services you signed in to with your account. Disconnect one to stop the agents from using it, or to sign in again with a different account.",
    "mcpConnectionsAvailableDescription": "The integrations of the agents you use that you have not signed in to yet. You can connect them now, without waiting for the agent to ask.",
    "mcpConnectionConnected": "{name} account connected",
    "mcpConnectionConnectFailed": "Signing in to {name} did not work. Try again, and if it keeps failing, tell whoever runs the agent.",
    "mcpConnectionUsedBy": "Used by {agents}",
    "mcpConnectionUsedByNone": "No agent uses it",
    "noMcpConnections": "No connected integrations",
    "userMcpConnectionsEmpty": "This user has not signed in to any integration with their own account.",
    "mcpConnectionRevokeQuestion": "Revoke {user}'s sign-in to {name}?",
    "mcpConnectionRevokeDescription": "The agents will no longer use their {name} account. The provider is asked to revoke it too, where it supports that; otherwise the authorization stays valid there until it expires. To use it again, {user} has to sign in themselves. They will receive a notification.",
    "mcpConnectionRevokedAtProvider": "Sign-in to {name} revoked, at the provider too",
    "mcpConnectionRevokedHere": "Sign-in to {name} revoked here. The provider did not confirm the revocation: the authorization may stay valid there until it expires.",
    "mcpServerCheckError": "Error while checking MCP Server: {error}",
    "mcpServerCheckSuccess": "MCP Server check successful",
    "mcpServerInvalidEndpoint": "This URL does not point to an MCP endpoint: the server replied with a web page. Check the path, MCP servers usually expose it under /mcp.",
    "mcpServersEmpty": "No MCP servers yet. Connect the first one to give the agent new tools.",
    "membersEmpty": "No members yet. Invite the first one to get started.",
    "memoriesEmpty": "Memories the agent saves about this user during conversations will appear here.",
    "memoryNotSynced": "Memory not synced with semantic search: it is not considered in answers until the repair sweep heals it.",
    "modelDiscoveryUnavailable": "This endpoint does not provide the list of its models: enter the ids by hand.",
    "modelDiscoveryFailed": "We could not read the list of models from the endpoint: only the models already saved are shown.",
    "modelPricesUnchanged": "No price changed.",
    "modelPricesUpdated": "Updated the price of one model: {models}. | Updated the prices of {count} models: {models}.",
    "modelProviderDeleted": "Endpoint deleted.",
    "moveDocumentSuccess": "Document moved successfully",
    "noActiveSessions": "No other active sessions",
    "noApiKeys": "No API keys",
    "noChats": "No chat available",
    "noConnectedAccounts": "No connected accounts",
    "noConversations": "No conversations found",
    "noConversationsHint": "Start a new chat to see it appear here.",
    "noCreditsData": "No credit data available",
    "noEndpointLogs": "No calls to this endpoint yet",
    "noEndpointModels": "No model available: the endpoint listed none.",
    "modelRemoved": "Model removed.",
    "noGdprRequests": "No GDPR requests",
    "noLinkedAgents": "No linked agents",
    "noNotifications": "No notifications",
    "noOptions": "No options",
    "noOrganizations": "No organizations",
    "noResults": "No results",
    "noSearchResults": "Nothing matches your search. Clear it to see everything.",
    "notificationsEmpty": "No notifications sent yet. Create the first one to reach your users.",
    "oauthConfigIncomplete": "OAuth configuration incomplete. Set the Client ID in the MCP server settings.",
    "oauthConnected": "OAuth authorization completed successfully",
    "oauthError": "Error during OAuth authorization",
    "organizationDisconnected": "Neither the platform gateway nor an endpoint of its own serves this organization, so its agents do not answer.",
    "organizationMembersEmpty": "No members yet. Add the first one to get started.",
    "organizationNotSelected": "No organization selected",
    "organizationsEmpty": "No organizations yet. Create the first one to get started.",
    "pageAccessNotice": {
      "forms": "The agent can read this page and fill in its forms.",
      "full": "The agent can read and use this page for you: you will see it act and can stop it.",
      "read": "The agent can read this page."
    },
    "pageNotFound": "Page not found",
    "passwordChangeSuccess": "Password changed successfully",
    "passwordResetSuccess": "Password reset. Every session of the account has been closed: sign in with the new password.",
    "profileOrganizationsEmpty": "The organizations you belong to appear here.",
    "readError": "Error while reading",
    "reasoningAgent": "This is a reasoning agent. It is not designed to maintain the conversation history, each message is processed independently.",
    "recoverPasswordSuccess": "Recovery email sent successfully",
    "refillFailed": "Refill failed. Try again later.",
    "refillSuccess": "Refill completed successfully",
    "refreshSuccess": "Refresh completed successfully",
    "releaseNotesEmpty": "No release notes published yet. Updates will be listed here as they ship.",
    "removeSuccess": "Removal completed successfully",
    "renameFolderSuccess": "Folder renamed successfully",
    "revisedAnswersEmpty": "No revised answers yet. Create the first one to teach the agent a better reply.",
    "selectedCount": "{count} of {total} selected",
    "sendInvitationConfirm": "Are you sure you want to resend the invitation to {email}?",
    "sessionRevoked": "Session signed out",
    "sessionsEmpty": "Signing in from another device or browser opens a new session, listed here.",
    "setPasswordDescription": "For now you sign in only through a connected account. Set a password to sign in with email and password too: we will email you a link to create it. Creating it closes every open session, this one included.",
    "setPasswordLinkSent": "We sent the link to {email}.",
    "sharedSuccess": "Document shared successfully",
    "sitemapUrlRequired": "Sitemap URL is required",
    "startUrlRequired": "Start URL is required",
    "subAgentsEmpty": "Connect an agent to delegate part of the conversation to it.",
    "submitError": "Error while saving",
    "submitSuccess": "Save completed successfully",
    "success": "Success",
    "testExecutionError": "Error executing test",
    "typeToSearch": "Start typing to search…",
    "unauthorized": "You do not have permission to manage channels.",
    "unbanSuccess": "User unbanned successfully",
    "unblockChatSuccess": "Conversation unblocked successfully",
    "unlinkAgentConfirm": "The document stays available to the other agents linked to it.",
    "unlinkDocumentConfirm": "It stays available to the other agents linked to it.",
    "unlinkLastAgentDeleteConfirm": "The document is permanently deleted, because no other agent is linked to it.",
    "unlinkSuccess": "Document unlinked successfully",
    "unlinkSyncedFolderConfirm": "Syncing stops. The folder and its documents stay with the agent and can be edited like any other from now on: to remove them, delete the folder.",
    "unsavedChanges": "Save or discard your changes first",
    "urlAlreadyImported": "Already imported",
    "urlAlreadyImportedLink": "This URL has already been imported. Do you want to link it to the current agent?",
    "userApiKeysEmpty": "Keys this user creates from their profile for programmatic access will appear here.",
    "userChatsEmpty": "Conversations this user has with any agent will appear here.",
    "userOrganizationsEmpty": "This user does not belong to any organization yet. Add the first one.",
    "userUpdateSuccess": "User profile updated successfully",
    "usersEmpty": "No users yet. Create the first one to get started.",
    "voiceCancelled": "I have cancelled.",
    "voiceConfirmed": "I confirm.",
    "voiceConnecting": "Connecting…",
    "voiceConnectionDone": "I have completed the connection.",
    "voiceFailed": "The voice session stopped",
    "voiceInterrupted": "Try again, or continue in writing.",
    "voiceListening": "Listening",
    "voiceLocationRefused": "I would rather not share my location.",
    "voiceLocationShared": "My location is {place}.",
    "voiceMuted": "Microphone muted",
    "voiceNoAnswer": "The agent could not produce an answer for this call. Try again, or continue in writing.",
    "voiceSpeaking": "The agent is speaking",
    "voiceTookTooLong": "The answer took too long for the call. Try again, or continue in writing: the answer will appear here as soon as it is ready.",
    "warning": "Warning",
    "webSourceCreated": "Source created: the folder “{name}” will receive new pages.",
    "webSourceCreateError": "The source could not be created, and no page was imported.",
    "webSourceEditable": "Discovered pages stay editable. Unlinking the source leaves them where they are, with their automatic refresh.",
    "webSourceRemovalHeld": "The sitemap no longer lists {count} pages: too many at once to remove without a check, so nothing was removed.",
    "webSourceConfirmRemovalQuestion": "The next check takes out of the knowledge base the pages the sitemap no longer lists, up to {count}. Their content stays in the database.",
    "unlinkWebSourceConfirm": "The source stops looking for new pages. The folder and its pages stay, with their automatic refresh.",
    "contactFormRecord": "The agent showed the contact form. If the user sent it, the contact is in Contacts.",
    "contactFormRecordPrefilled": "The agent showed the contact form with these details. If the user sent it, the contact is in Contacts.",
    "documentsEmptyTitle": "No documents yet",
    "documentsEmptyFolderTitle": "This folder is empty",
    "mcpServerToolsUnavailable": "Tools not available"
  },
  "chatFilePreview": {
    "download": "Download",
    "close": "Close the preview",
    "revisionsOf": "Tracked changes by {authors}, not accepted yet:",
    "removed": "removed",
    "added": "added",
    "revisionBy": "Tracked change by {author}",
    "image": "Image",
    "truncated": "The preview stops here: the rest of the document is in the file to download.",
    "true": "TRUE",
    "false": "FALSE",
    "staleFormulas": "Values shown with a dash update when you open the file in Excel.",
    "missingValue": "Computed when you open the file in Excel",
    "moreRows": "The file holds one more row. | The file holds {count} more rows.",
    "moreColumns": "The file holds one more column. | The file holds {count} more columns.",
    "unavailable": "This file has no preview: download it to open it.",
    "open": "Open",
    "readOnly": "Preview, read only",
    "versions": "Versions",
    "previousVersion": "Previous version",
    "nextVersion": "Next version",
    "versionOf": "Version {version} of {count}",
    "modes": "How to show the tracked changes",
    "modeMarkup": "With changes",
    "modeMarkupShort": "Changes",
    "modeAccepted": "Accepted",
    "modeOriginal": "Original",
    "restore": "Restore this version",
    "expand": "Enlarge",
    "shrink": "Back beside the chat",
    "cell": "Cell",
    "formulaBar": "Formula bar",
    "sheets": "Sheets",
    "computedFormulas": "Values computed in the chat: Excel computes them again when you open the file.",
    "average": "Average",
    "count": "Count",
    "sum": "Sum",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "fitWidth": "Fit to width",
    "pageOf": "Page {page} of {count}",
    "words": "{count} word | {count} words",
    "outline": "Outline",
    "changes": "Changes ({count})",
    "noHeadings": "The document has no headings."
  },
  "messagePart": {
    "audioTranscribing": "Transcribing the audio…",
    "audioTranscript": "Transcript",
    "audioTranscriptFailed": "It could not be transcribed",
    "audioTranscriptNoSpeech": "No speech could be heard in it",
    "audioTranscriptOff": "Not transcribed: transcription is off for this organization",
    "disconnectOAuthConnection": "Disconnecting…",
    "requestAccountLink": "Sending the sign-in link…",
    "unlinkAccount": "Unlinking the number…",
    "createSpreadsheet": "Creating the spreadsheet…",
    "createWordDocument": "Creating the Word document…",
    "editSpreadsheet": "Editing the spreadsheet…",
    "editSpreadsheetCells": "{count} cell changed | {count} cells changed",
    "editWordDocument": "Editing the Word document…",
    "editWordDocumentParagraphs": "{count} paragraph changed | {count} paragraphs changed",
    "editWordDocumentRevisions": "{count} paragraph changed as a tracked change | {count} paragraphs changed as tracked changes",
    "chatFileParagraphChanged": "Changed",
    "chatFileParagraphAdded": "Added",
    "chatFileParagraphDeleted": "Deleted",
    "chatFileTableRowAdded": "Row added",
    "chatFileTableRowDeleted": "Row deleted",
    "chatFileVersionSummary": "Version {version}: {changed}",
    "chatFileMoreChanges": "and {count} more change | and {count} more changes",
    "chatFileSheet": "Sheet {name}",
    "chatFileRow": "Row {row}",
    "chatFileNewSheet": "New sheet, with {count} row | New sheet, with {count} rows",
    "chatFileCell": "Cell",
    "chatFileBefore": "Before",
    "chatFileAfter": "After",
    "chatFileRefreshPivots": "The pivot tables still show the old figures: refresh them in Excel with Data, Refresh All.",
    "chatFileUpdateTableOfContents": "The table of contents does not update by itself: in Word, right click it and choose Update Field.",
    "chatFileRevisionAccepted": "Revision accepted",
    "chatFileRevisionRejected": "Revision rejected",
    "chatFileRestored": "Version {version}: version {restored} restored",
    "chatFileRestoreRequest": "Restore version {version} of {filename}",
    "chatFileRestoreRequestById": "Restore version {version} of {filename} (id {fileId})",
    "enableTools": "Enabling tools…",
    "expandChunkContext": "Reading more context…",
    "fetchTeamsChannelHistory": "Reading channel history…",
    "geocode": "Looking up a location…",
    "getWeather": "Fetching weather data…",
    "hostToolFailed": "error",
    "hostToolNoAnswer": "no answer",
    "pageControlActive": "The agent is using the page",
    "pageTool": {
      "back": "Going back…",
      "click": "Clicking on the page…",
      "fill": "Filling in a field…",
      "find": "Finding on the page…",
      "form": "Filling in a form…",
      "hover": "Pointing at an element…",
      "navigate": "Opening a page…",
      "press": "Pressing a key…",
      "read": "Reading a section of the page…",
      "scroll": "Scrolling the page…",
      "snapshot": "Reading the page…",
      "wait": "Waiting for the page…"
    },
    "querySpreadsheet": "Querying the spreadsheet…",
    "readChatAttachment": "Rereading an attached file…",
    "readDocumentFile": "Reading the original document…",
    "readEarlierMessages": "Rereading earlier messages…",
    "readSpreadsheet": "Reading the spreadsheet…",
    "readWordDocument": "Reading the Word document…",
    "reasoning": "Reasoning…",
    "recallUserMemory": "Recalling user memories…",
    "requestGeolocation": "Requesting location…",
    "requestOAuthConnection": "Connecting…",
    "requestOAuthConnectionButton": "Connect {name}",
    "requestOAuthConnectionInfo": "Authorization requested to access {name}'s data.",
    "requestOAuthConnectionPrompt": "To access {name} data, you need to authorize the connection.",
    "requestOAuthConnectionSuccess": "Successfully connected to {name}.",
    "revisedAnswers": "Search frequently asked questions…",
    "runSubagent": "Delegating to a sub-agent…",
    "runWorker": "Delegating to a worker…",
    "saveUserMemory": "Updating user memory…",
    "scheduleWakeup": "Scheduling the next check…",
    "searchingDocuments": "Memory search…",
    "sendChatFile": "Sending the file again…",
    "shareDocument": "Preparing the document…",
    "shareDocumentValidUntil": "Link valid until {date}",
    "showArtifact": "Preparing content…",
    "showCalendarEvent": "Creating calendar event…",
    "showComparison": "Building comparison…",
    "showContactForm": "Creating contact form…",
    "showDiagram": "Rendering diagram…",
    "showEmail": "Composing email…",
    "showForm": "Creating form…",
    "showImageGallery": "Loading gallery…",
    "showLocation": "Loading location…",
    "showMessage": "Composing message…",
    "showMultipleChoice": "Show the options…",
    "showProducts": "Loading products…",
    "showQrCode": "Generating QR code…",
    "showSources": "Loading sources…",
    "showSuggestedReply": "Suggest a reply…",
    "showVideo": "Loading video…",
    "showWeather": "Loading forecast…",
    "showWebPages": "Loading pages…",
    "stepCount": "{n} step | {n} steps",
    "stepDocument": "Document",
    "stepDropped": "{n} query left out: over the limit | {n} queries left out: over the limit",
    "stepError": "Error",
    "stepExcerpts": "{n} excerpt | {n} excerpts",
    "stepInput": "Input",
    "stepItems": "{n} item | {n} items",
    "stepNoResults": "No results found",
    "stepOutput": "Output",
    "stepRepeated": "{n} excerpt already found earlier | {n} excerpts already found earlier",
    "stepTimedOut": "{n} search did not answer in time: results may be missing | {n} searches did not answer in time: results may be missing",
    "steps": "Processing",
    "streaming": "Loading…",
    "tool": "Running a tool…",
    "type": {
      "custom": "Provider data",
      "data": "Data",
      "file": "File",
      "reasoning": "Reasoning",
      "sourceDocument": "Source document",
      "sourceUrl": "Web source",
      "stepStart": "Step start",
      "text": "Text"
    },
    "webSearch": "Searching the web…",
    "pageStep": {
      "click": "Clicking “{name}”…",
      "fill": "Filling in “{name}”…",
      "find": "Finding “{text}” on the page…",
      "hover": "Pointing at “{name}”…",
      "navigate": "Opening {url}…",
      "press": "Pressing {key} on “{name}”…"
    }
  },
  "openaiApi": {
    "access": "API access",
    "accessOff": "Off. No outside client can use the agent: switch it on to see how to connect one.",
    "accessOn": "On. The agent answers calls made with an API key of the organization.",
    "agentAsModel": "Agent as a model",
    "agentAsModelDescription": "Any client that speaks OpenAI's Chat Completions API (n8n, LangChain, the openai SDKs) can use this agent as if it were a model, with an API key.",
    "alertOff": "The agent no longer answers through the API.",
    "alertOn": "The agent now answers through the API.",
    "apiKeySummary": "Personal: the agent answers with the permissions of whoever created it.",
    "baseUrl": "Base URL",
    "baseUrlSummary": "The client adds the path of each call by itself.",
    "connection": "Connection",
    "connectionDescription": "In the client, enter the base URL, the model and an API key.",
    "conversations": "Conversations",
    "conversationsSummary": "To keep the thread of a conversation, generate a unique id (a UUID, for instance) and send the same one on every call, as below: the agent remembers the earlier messages and the conversation is saved. Without it, every call stands alone.",
    "examples": "Examples",
    "externalContextSummary": "To tell the agent what your app knows about the user, send it as a JSON object in a string, as below. The agent keeps only the fields it declares, as it does for the widget.",
    "model": "Model",
    "modelSummary": "The agent's id, to use as the model name.",
    "n8nCredential": "Create an OpenAI credential with your API key and the base URL of this page.",
    "n8nModel": "In the OpenAI Chat Model node, choose this agent's id as the model."
  },
  "organizationDeletion": {
    "action": "Delete the organization",
    "blocked": "The deletion cannot start",
    "blocker": {
      "deletion_exists": "The organization already has a deletion.",
      "outside_reference": "{rows} rows of another organization use its data ({table}, column {column}): for instance an agent that uses one of its agents as a sub-agent, or one of its MCP servers. Remove them first.",
      "unclassified_table": "The table {table} is not in the scope of the deletion: classify it in the code before deleting."
    },
    "confirm": "Delete for good",
    "confirmHint": "Type {slug} to confirm.",
    "confirmLabel": "Organization slug",
    "copied": "Report copied.",
    "copy": "Copy the report",
    "deleted": "Deleted",
    "deletedNotice": "This organization has been deleted. Its consumption stays, for the reports, and so does the report of the deletion.",
    "description": "Deletes the organization and its data for good: agents, documents, files, conversations, memories and the accounts that have data only here. The consumption data and the organization's name stay, for the reports. From the confirmation nobody reaches it any more, and there is no going back.",
    "dialogTitle": "Delete {name}?",
    "error": "Last error, after {attempts} attempts: {error}",
    "finishedAt": "Completed on {date}.",
    "goes": "What goes",
    "group": {
      "delete": "Anonymous users deleted (widget and channels)",
      "detach": "Accounts that stay, without what they had here: they have data in other organizations or administer the platform",
      "erase": "Accounts anonymized: they have data only here"
    },
    "item": {
      "agents": "Agents",
      "attachments": "Conversation attachments",
      "chats": "Conversations",
      "chunks": "Indexed parts of documents",
      "consumption": "Consumption data (rows)",
      "documents": "Documents",
      "leads": "Collected contacts",
      "memories": "Memories",
      "organization": "The organization, with name and slug, without its logo",
      "others": "Other data: settings, links, logs (rows)",
      "points": "Points in the document index",
      "pointsUnknown": "Not readable now"
    },
    "people": "People",
    "progress": "Step {current} of {total}: {step}",
    "report": "Report",
    "reportText": {
      "copies": "Copies: the database backups expire within 7 days, the deleted files stay recoverable in the storage for 7 days, the backups of the vector index machine expire within 30 days. Within 30 days of the deletion none is left.",
      "deletedHeading": "Deleted:",
      "files": "files: {deleted} deleted, {missing} already missing, {kept} kept because another organization uses them",
      "heading": "Deletion of the organization {name} (slug {slug}, id {id})",
      "kept": "the consumption data ({count} rows) and the organization row with its name and slug, for the reports",
      "keptHeading": "Kept:",
      "outside": "Outside the platform: the technical logs expire with their retention; registrations with third parties (the Teams app in the customer's tenant, WhatsApp numbers, Entra apps) are removed by the customer.",
      "people": "people: {erase} accounts anonymized, {delete} anonymous users deleted, {detach} accounts that stay without this organization's data",
      "points": "index points: {chunks} of documents, {memories} of memories",
      "requested": "Requested by {name} on {date}, completed on {finished}.",
      "rows": "database rows at the confirmation: {count}",
      "shortUrls": "short links: {count}",
      "signIns": "integration sign-ins ended: {removed}, {revoked} of them revoked at the provider too",
      "verified": "final check: no row of the organization left in the emptied tables, no point in the document index"
    },
    "requestedBy": "Requested by {name} on {date}.",
    "retry": "Resume",
    "started": "Deletion started: from now on nobody reaches the organization. The data is erased in batches, over the minutes or hours that follow depending on its volume.",
    "stays": "What stays",
    "status": {
      "completed": "Completed",
      "failed": "Stopped",
      "pending": "Waiting",
      "running": "Running"
    },
    "step": {
      "files": "Files",
      "report": "Final check",
      "rows": "Data",
      "tombstone": "Organization",
      "users": "People",
      "vectors": "Document and memory index"
    },
    "title": "Deletion"
  },
  "organizationLimits": {
    "legend": "Limits",
    "membersHint": "Empty: no limit. Users who arrive from the widget count too.",
    "membersInvalid": "Enter a whole number of at least 1, or leave it empty.",
    "membersLabel": "Maximum members"
  },
  "pagePointer": {
    "ask": "Ask",
    "hint": "Click an element of the page",
    "pointed": "Pointed at on the page",
    "remove": "Remove",
    "selected": "Text selected on the page",
    "start": "Point at the page"
  },
  "placeholder": {
    "allProviders": "All providers",
    "apiToolName": "e.g. get-product-availability",
    "apiToolUrl": "https://api.example.com/resource/{param}",
    "askAnything": "Type your message…",
    "autoDetect": "Auto detect",
    "autoGenerated": "Auto-generated if left blank",
    "comment": "Write your comment…",
    "completeName": "Enter full name",
    "constValue": "Constant value",
    "customAnswer": "Type your answer…",
    "description": "Enter description",
    "documentContent": "Enter document content",
    "documentName": "Enter document name",
    "documentOriginAll": "All origins",
    "documentRefreshAll": "All updates",
    "documentStatusAll": "All statuses",
    "documentUrl": "Enter the URL of the web page to import",
    "email": "Enter your email address",
    "endDate": "Select end date",
    "enterYourQuestion": "Enter your question…",
    "insert": "Type here…",
    "insertOrigin": "https://example.com",
    "insertImageHost": "images.example.com",
    "limit": "Enter the limit",
    "loading": "Loading…",
    "mcpServerHealthCheckPath": "Enter the health check endpoint",
    "mcpServerUrl": "Enter the MCP server URL",
    "model": "Select model",
    "modelEndpointBaseUrl": "https://internal-proxy/v1",
    "name": "Enter name",
    "noHostToolsAllowed": "No tool allowed",
    "noPageAccessExcludeSelectors": "No excluded area besides data-agent-ignore",
    "noTrustedOrigins": "No trusted origins configured",
    "noImageHosts": "No image hosts: images from other hosts wait for a click",
    "oauthAuthorizationUrl": "e.g. https://provider.com/oauth/authorize",
    "oauthClientId": "e.g. my-client-app",
    "oauthClientSecret": "Enter the client secret",
    "oauthScopes": "e.g. read:contacts write:contacts",
    "oauthTokenUrl": "e.g. https://provider.com/oauth/token",
    "pages": "1, 4, 6, 8-12",
    "pasteJsonSample": "Paste a JSON example to generate the schema",
    "phone": "Enter your phone number",
    "prompt": "Enter the prompt",
    "request": "Request…",
    "search": "Search…",
    "secretEdit": "Leave blank to keep the current secret",
    "select": "Select",
    "selectAgent": "Select an agent",
    "selectLanguage": "Select language",
    "selectPriority": "Select priority",
    "similarity": "Enter the similarity",
    "sitemapUrl": "https://example.com/sitemap.xml",
    "slug": "Enter a URL-friendly slug",
    "startDate": "Select start date",
    "startUrl": "https://example.com",
    "temperature": "Enter the temperature",
    "title": "Enter title",
    "uploadFile": "Upload a file",
    "emailAddress": "name{'@'}company.com"
  },
  "platformLink": {
    "title": "Link WhatsApp",
    "cardTitle": "Link your WhatsApp number",
    "description": "Whoever writes from this number on WhatsApp will use your account, its integrations included: mail, calendar, files. Link only a number that is yours.",
    "summaryAvailable": "It will use the account {email}.",
    "summaryReplaces": "It will replace {phone}, which uses your account today.",
    "summaryLinkedHere": "It already uses your account.",
    "summaryLinkedElsewhere": "It uses another account. Unlink it there first, or ask the agent on WhatsApp to unlink it.",
    "summaryExpired": "This link has expired. Ask the agent on WhatsApp for a new one.",
    "summaryInvalid": "This link is not valid, or it was already used. Ask the agent on WhatsApp for a new one.",
    "summaryLinked": "Linked. Go back to WhatsApp: the agent has written to you there.",
    "requestedAt": "Link requested at {issued}, valid until {expires}.",
    "doNotConfirm": "If someone sent you this link, do not confirm.",
    "confirmOnlyIf": "Confirm only if you asked for this link yourself, from the phone with this number, in the last hour.",
    "link": "Link {phone} to my account",
    "replace": "Link {phone} instead of {current}",
    "linked": "The WhatsApp number {phone} now uses your account.",
    "identitiesTitle": "Linked numbers",
    "identitiesDescription": "The messaging numbers that write as your account. Unlink one to stop it from using your account and its integrations.",
    "linkedAt": "Linked on {date}",
    "unlinkQuestion": "Unlink {phone}?",
    "unlinkDescription": "Whoever writes from this number will no longer use your account and its integrations. The conversations stay in your account.",
    "unlinked": "{phone} no longer uses your account."
  },
  "problemReasons": {
    "conflict": {
      "agent-visibility-in-use": "A visibility you are switching off is still used by {agents}: change their visibility first."
    },
    "feature-disabled": {
      "agent-visibility-off": "This visibility is switched off for your organization: choose another one."
    },
    "file-upload-validation": {
      "audio-too-large": "The recording is over 100 MB, the most that is transcribed: upload a shorter or more compressed copy, for example an m4a or an mp3."
    },
    "gateway-disabled": {
      "gateway-disabled": "This organization does not use the platform AI gateway, and this document needs something that runs there: the embedding, if it is not active on the endpoint (Models, Embedding section), or the document's AI model, to replace with one of the endpoint.",
      "transcription-off": "This organization does not use the platform AI gateway, which is where audio recordings are transcribed: upload the transcript as a text file instead."
    },
    "input-validation": {
      "header-env-placeholder": "A header refers to an environment variable of the platform, which API tools no longer resolve: header values are sent exactly as written, so type the value itself.",
      "header-origin-changed": "The URL points to another host: type the values of the headers again, the saved ones stay with the previous host.",
      "header-url-host-placeholder": "A tool with headers needs a fixed host: the scheme, host and port of its URL cannot hold a placeholder the model fills in.",
      "header-value-missing": "A header has no value: type it, or remove the header.",
      "last-owner": "An organization needs at least one owner: make another member an owner first.",
      "restricted-agent-platform": "A Private agent cannot be connected to Teams or WhatsApp: there whoever writes to the bot uses the agent, and nobody checks who they are. Choose another visibility, or switch the agent's connections off first.",
      "restricted-sub-agent": "A Private agent can be a sub-agent only of another Private agent: whoever uses an agent also uses its sub-agents, and is not checked on them. Make this agent Private first, or choose another sub-agent.",
      "restricted-sub-agent-links": "This visibility is not allowed by the sub-agent links with {agents}: a Private agent can be a sub-agent only of another Private agent, since whoever uses an agent also uses its sub-agents. Remove those links first, or choose another visibility.",
      "secret-body-method": "A GET or DELETE request sends no body: put the secret parameters in the query string, or change the method.",
      "secret-env-placeholder": "A secret parameter refers to an environment variable of the platform, which API tools do not resolve: type the value itself.",
      "secret-origin-changed": "The URL points to another host: type the values of the secret parameters again, the saved ones stay with the previous host.",
      "secret-path-placeholder": "A secret parameter cannot fill a placeholder of the URL path: the path is filled in by the model, which never sees the secret.",
      "secret-url-host-placeholder": "A tool with secret parameters needs a fixed host: the scheme, host and port of its URL cannot hold a placeholder the model fills in.",
      "secret-value-missing": "A secret parameter has no value: type it, or remove the parameter."
    },
    "model-unavailable": {
      "embedding-endpoint-off": "The endpoint that computes this organization's embedding is off: switch it back on in the Models page.",
      "endpoint-off": "This document needs the organization's endpoint, for the embedding or for the document's AI model, and the endpoint is off: switch it back on in the Models page."
    },
    "provider-request-failed": {
      "timeout": "The external provider did not answer in time: try again in a moment."
    }
  },
  "problems": {
    "conflict": "A conflict occurred. The resource may already exist.",
    "conversation-blocked": "This conversation has been blocked.",
    "credit-exhausted": "Credits exhausted. Contact your administrator.",
    "embedding-identity-failed": "The endpoint does not serve the declared embedding model: its vectors would not match the knowledge base. Check the model id.",
    "entity-not-found": "Resource not found or disabled.",
    "external-token-required": "This MCP server receives the token of the user calling the agent, and no call has carried one yet: its tools show up here after the first one.",
    "feature-disabled": "This feature is not enabled for your organization.",
    "file-upload-disabled": "File upload is not enabled for this agent.",
    "file-upload-validation": "Invalid file: check size, type, or number of files.",
    "gateway-disabled": "This organization does not use the platform AI gateway, so its models are not available. Use a model of the organization's own endpoint.",
    "gdpr-erasure-blocked-sole-owner": "The account is the only owner of one or more organizations: transfer the ownership or delete the organizations before deleting it.",
    "hubspot-missing-scopes": "The HubSpot token is missing required permissions. Add the \"crm.objects.owners.read\" scope.",
    "input-validation": "Input validation failed. Check the data format.",
    "internal-server-error": "An unexpected error occurred. Try again later.",
    "mcp-endpoint-invalid": "This URL does not point to an MCP endpoint. Check the path, MCP servers usually expose it under /mcp.",
    "method-not-allowed": "HTTP method not allowed for this endpoint.",
    "model-default-unavailable": "A default model has to be a model the organization can use: pick another default first.",
    "model-not-chat": "This is an embedding model, not a chat model: it cannot answer an agent.",
    "model-price-missing": "A model cannot be switched on without a price: pick a model it costs like, or type the price.",
    "model-unavailable": "The chosen model is not available to this organization: pick another one.",
    "not-found": "Page not found.",
    "oauth-authorization-required": "OAuth authorization required. Complete the authorization flow for this MCP server.",
    "oauth-config-incomplete": "OAuth configuration incomplete. Set the Client ID to enable OAuth.",
    "origin-not-allowed": "Request origin is not allowed.",
    "price-list-unavailable": "The gateway price list cannot be reached right now: try again, or type the price by hand.",
    "provider-request-failed": "The external provider refused the request.",
    "rate-limit-exceeded": "Too many requests. Try again later.",
    "two-factor-required": "An organization you belong to requires two-step verification: set it up to continue.",
    "unauthorized": "Authentication required. Sign in.",
    "validation-error": "Validation error. Check the submitted data."
  },
  "profileSection": {
    "backToApp": "Back to the app",
    "general": {
      "title": "Profile and preferences",
      "description": "Your name and picture, and how the app looks to you.",
      "pictureHint": "PNG or JPG."
    },
    "notifications": {
      "title": "Notifications",
      "description": "Which notices you get, in the app and by email.",
      "groups": "Notification types",
      "alwaysOn": "Account security notices and messages from administrators always arrive.",
      "loadFailed": "Your preferences could not be read.",
      "channel": {
        "inApp": "App",
        "email": "Email"
      },
      "agent_replies": {
        "title": "Agent replies",
        "summary": "When an agent you asked to check again has news for you."
      },
      "documents": {
        "title": "Documents and sources",
        "summary": "Documents that fail to process, and pages removed from a synced source."
      },
      "integrations": {
        "title": "Integrations and keys",
        "summary": "An integration sign-in ended by an administrator, and API keys about to expire."
      },
      "flagged_conversations": {
        "title": "Flagged conversations",
        "summary": "Conversations the analysis flagged or blocked."
      },
      "usage_limits": {
        "title": "Usage limits",
        "summary": "When the organization uses up the day's automatic runs."
      }
    },
    "security": {
      "title": "Security",
      "description": "How you sign in, and where you are signed in.",
      "signIn": "Sign-in",
      "passwordSummary": "Used with {email} to sign in.",
      "connectedAccountsNote": "to sign in without a password",
      "connected": "Connected",
      "devices": "No devices | One device | {count} devices",
      "deviceOn": "{browser} on {os}"
    },
    "integrations": {
      "title": "Integrations and API keys",
      "description": "Services your agents reach for you, and keys to call the platform.",
      "available": "To connect",
      "keyExpires": "Expires {date}",
      "keyNeverExpires": "No expiry",
      "keyRequests": "No requests | One request | {count} requests"
    },
    "organizations": {
      "title": "Organizations",
      "description": "Where you work: switch, create an API key, leave.",
      "current": "Where you are now",
      "onlyYou": "Only you",
      "members": "{count} member | {count} members",
      "memberSince": "Member since {date}",
      "asksTwoFactor": "Asks for two-step verification",
      "empty": "You are not a member of any organization. If you had an invitation, it may have expired: ask whoever sent it for a new one."
    },
    "data": {
      "title": "My data",
      "description": "Files you uploaded in chats, a copy of everything, your account.",
      "account": "Your account"
    }
  },
  "refreshInterval": {
    "daily": "Every day",
    "manual": "Manual",
    "monthly": "Every month",
    "weekly": "Every week"
  },
  "releaseNotes": {
    "heading": "What's new",
    "installed": "You're on",
    "lead": "Latest features, improvements and fixes.",
    "writtenInEnglish": "Release notes are written in English."
  },
  "role": {
    "admin": "Administrator",
    "member": "Member",
    "owner": "Owner",
    "user": "User"
  },
  "nav": {
    "organization": "Organization",
    "configure": "Configure",
    "monitor": "Monitor",
    "allAgents": "All agents",
    "agentSettings": "Settings",
    "agentTry": "Try",
    "searchAgent": "Search an agent",
    "searchChat": "Search a chat",
    "searchOrganization": "Search an organization",
    "allOrganizations": "All organizations"
  },
  "route": {
    "agentEndpoints": "API endpoints",
    "agents": "Agents",
    "apiTools": "API tools",
    "backoffice": "Backoffice",
    "branding": "Branding",
    "catalog": "Catalog",
    "channels": "Channels",
    "chatLogs": "Chat logs",
    "copatForYou": "Eight Wave for-U",
    "dashboard": "Dashboard",
    "dataProtection": "Data protection",
    "documents": "Documents",
    "endpointLogs": "Endpoint logs",
    "feedbacks": "Feedback",
    "frontoffice": "Frontoffice",
    "home": "Home",
    "integrations": "Integrations",
    "invitations": "Invitations",
    "leads": "Contacts",
    "mcpServer": "MCP server",
    "members": "Members",
    "models": "Models",
    "notFound": "Page not found",
    "notifications": "Notifications",
    "openaiApi": "OpenAI API",
    "organizations": "Organizations",
    "profile": "Profile",
    "reasoningLogs": "Reasoning logs",
    "releaseNotes": "Release notes",
    "requestPasswordReset": "Forgot password",
    "resetPassword": "Reset password",
    "revisedAnswers": "Revised answers",
    "signIn": "Sign in",
    "signUp": "Sign up",
    "subAgents": "Sub-agents",
    "system": "System",
    "twoFactor": "Two-step verification",
    "twoFactorSetup": "Set up two-step verification",
    "users": "Users",
    "video": "Video",
    "virtualAssistant": "Virtual assistant"
  },
  "showForm": {
    "completed": "Form completed",
    "noAnswerRecorded": "No answer recorded from the form: if the user replied, the answer is in the messages that follow.",
    "otherPlaceholder": "Other…",
    "step": "Step {current} of {total}"
  },
  "subAgentStatus": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "time": {
    "future": "in",
    "past": "ago",
    "unit": {
      "day": "day | days",
      "hour": "hour | hours",
      "minute": "minute | minutes",
      "second": "second | seconds"
    }
  },
  "toolApproval": {
    "afterColumn": "After",
    "approved": "Approved: the action was performed.",
    "assistantDiscardAgent": "The agent wants to discard the unsaved changes to “{name}”, yours included. Allow it?",
    "assistantLeaveUnsaved": "The agent wants to open another page: the unsaved changes on this one will be lost. Allow it?",
    "assistantSaveAgent": "The agent wants to save the changes to “{name}”. Allow it?",
    "beforeColumn": "Before",
    "cancelled": "Cancelled: the action was not performed.",
    "confirmed": "Confirmed: the agent proceeded with the action.",
    "denied": "Denied: the action was not performed.",
    "expired": "This request is no longer answerable: the action was not performed.",
    "fieldChecked": "yes",
    "fieldColumn": "Field",
    "fieldUnchecked": "no",
    "formFill": "The agent wants to fill in the form “{name}”. Allow it?",
    "formSubmit": "The agent wants to fill in and submit the form “{name}”. Allow it?",
    "hostCall": "The agent wants to use “{name}”. Allow it?",
    "noChanges": "No field changed since the agent read the form.",
    "pageAnswer": "The page asks: “{question}” The agent wants to answer “{name}”. Allow it?",
    "pageBack": "The agent wants to go back to the previous page. Allow it?",
    "pageClick": "The agent wants to click “{name}”. Allow it?",
    "pageElement": "an element",
    "pageFill": "The agent wants to write “{value}” in “{name}”. Allow it?",
    "pageFillFields": "The agent wants to fill in these fields. Allow it?",
    "pageFocused": "the focused element",
    "pageHover": "The agent wants to point at “{name}”. Allow it?",
    "pageNavigate": "The agent wants to open “{url}”. Allow it?",
    "pageNavigateUnknown": "The agent wants to open “{url}”, which the page does not show. Allow it?",
    "pageOpen": "The agent wants to open “{name}”: the page will change. Allow it?",
    "pagePress": "The agent wants to press {key} on “{name}”. Allow it?",
    "pageSubmit": "The agent wants to submit the form with “{name}”. Allow it?",
    "prompt": "Your confirmation is needed to continue:",
    "promptNamed": "To continue, the agent wants to use “{tool}”.",
    "unchangedFields": "{n} unchanged field | {n} unchanged fields"
  },
  "toolGroup": {
    "channels": "Messaging channels",
    "communication": "Communication",
    "delegation": "Delegation & automation",
    "knowledgeSearch": "Knowledge base & search",
    "locationWeather": "Location & weather",
    "personalization": "Personalization",
    "richContent": "Interactive content"
  },
  "toolGroupInfo": {
    "channels": "Extra capabilities on messaging platforms like Microsoft Teams.",
    "communication": "Emails, messages, contact forms, and calendar events.",
    "delegation": "Workers running in parallel, and checks the agent repeats by itself over time when the user asks.",
    "knowledgeSearch": "Knowledge base search, document sources, and web page suggestions.",
    "locationWeather": "Geolocation, geocoding, interactive maps, and weather forecasts.",
    "personalization": "Per-user memory, the user's own uploaded files and the spreadsheets they attach.",
    "richContent": "Structured content: artifacts, comparisons, image galleries, QR codes, and guided replies."
  },
  "toolSelection": {
    "cost": "Cost charged to the organization: {cost}",
    "enabled": "Brought back",
    "exposed": "Groups exposed to the model: probability {threshold} or higher, or used earlier",
    "failed": "Failed",
    "inputTokens": "Input tokens",
    "kind": {
      "api": "API tool",
      "mcp": "MCP server",
      "subagent": "Sub-agent"
    },
    "latency": "Evaluation time, limit {budget} ms",
    "leadFailed": "The evaluation failed or did not answer within {budget} ms: every group stayed exposed.",
    "missed": "Missed",
    "missedActive": "{n} used group had been left out, and the model had to bring it back | {n} used groups had been left out, and the model had to bring them back",
    "missedShadow": "{n} used group would have been left out | {n} used groups would have been left out",
    "mode": {
      "active": "Active",
      "shadow": "Shadow"
    },
    "modeHint": {
      "active": "Applied before the first step: the model saw only the groups with a check, and could bring the others back.",
      "shadow": "Recorded alongside the reply: the model saw every group, and the check is only compared with the calls."
    },
    "notCharged": "Not charged",
    "probability": "Probability that the message needs the group; exposed from {threshold}",
    "seeded": "Used earlier",
    "title": "Tool selection",
    "tools": "{n} tool | {n} tools",
    "used": "Used"
  },
  "tooltip": {
    "agentsUsedInfo": "Number of agents used compared to the maximum available.",
    "mcpConnectionStatus": {
      "active": "The agents use it on the user's behalf.",
      "orphan": "No agent uses it any more (the integration was deleted, switched off or removed from the agents), but the sign-in is still stored.",
      "stale": "Expired with no way to renew it: it is deleted the next time it is used, and the user will have to sign in again."
    },
    "requestsUsedInfo": "Number of requests used compared to the maximum allowed."
  },
  "turnEvaluation": {
    "cost": "Cost, not charged to the organization: {cost}",
    "leadFailed": "The evaluation failed or did not answer within {budget} ms: nothing was recorded.",
    "modeHint": "Recorded after the reply, with no effect: nothing reads these probabilities yet.",
    "probability": "Probability the evaluation model gives to the question: from 0.5 it leans towards yes",
    "question": {
      "abusive": "Abusive message",
      "asksHuman": "Asks for a human operator",
      "durableFact": "Lasting fact about the user",
      "informationGap": "A piece of information is missing, not a capability",
      "manipulation": "Tries to manipulate the agent",
      "missingInfo": "The reply says the information is missing"
    },
    "title": "Evaluation after the reply",
    "version": "Questions version {version}"
  },
  "twoFactor": {
    "adminBackupCodes": "No backup codes left | One backup code left | {count} backup codes left",
    "adminChanges": "Latest changes",
    "adminChangesEmpty": "No changes yet.",
    "adminChangesHint": "From the notices sent to the user, who can delete them.",
    "adminDevicesForgotten": "The trusted devices were forgotten.",
    "adminFailedAttempts": "One wrong code in a row | {count} wrong codes in a row",
    "adminFilterEmpty": "No user is in this state.",
    "adminForgetDevices": "Forget trusted devices",
    "adminForgetDevicesDescription": "On each of them the next sign-in asks for the code again. We will tell them by email.",
    "adminForgetDevicesQuestion": "Forget the trusted devices of {name}?",
    "adminLocked": "Paused after too many wrong codes, until {date}.",
    "adminPasskeySynced": "Synced across their devices",
    "adminRemovePasskeyDescription": "It will no longer sign them in. Sessions already open stay open: if the device is lost, close them from Active sessions. We will tell them by email.",
    "adminRemovePasskeyQuestion": "Remove the passkey {passkey} of {name}?",
    "adminRequiredPending": "Required by {organizations} and not set up yet: their next page stops on the setup.",
    "adminStateNoneHint": "No second factor and no passkey",
    "adminSummaryAll": "All",
    "adminTrustedDevices": "No trusted devices | One trusted device, until {date} | {count} trusted devices, the last one until {date}",
    "adminUnlock": "Unlock",
    "adminUnlockDescription": "Do it only if they asked: the pause slows down whoever is trying their codes. We will tell them by email.",
    "adminUnlocked": "Unlocked: they can enter their code again.",
    "adminUnlockQuestion": "Unlock the two-step verification of {name}?",
    "adoptionRatio": "{count} of {total}",
    "adoptionState": {
      "totp": "With the app",
      "otp": "With email",
      "passkey": "With a passkey",
      "required": "To set up",
      "none": "No verification"
    },
    "adoptionTitle": "Protected members",
    "adoptionTitleUsers": "Protected users",
    "backupCode": "Backup code",
    "backupCodesDescription": "Each code works once, in place of the app's. Keep them somewhere safe: without your phone and without these codes, only an administrator can restore your access.",
    "backupCodesFileHeader": "{name} backup codes. Each one works once.",
    "backupCodesReplaced": "Here are your new backup codes: the old ones no longer work. Save them now, they will not be shown again.",
    "backupCodesSaved": "I saved the codes",
    "badge": "Two-step verification",
    "challengeApp": "Enter the 6-digit code from your authenticator app.",
    "challengeBackup": "Enter one of the backup codes you saved.",
    "challengeEmailSending": "We are sending a code to your email.",
    "challengeEmailSent": "We sent a 6-digit code to your email. It expires in 5 minutes.",
    "challengeTitle": "Two-step verification",
    "code": "6-digit code",
    "column": "2FA",
    "disabledMessage": "Two-step verification is off.",
    "enabledMessage": "Two-step verification is on.",
    "manualKey": "Can't scan it? Enter this key in the app:",
    "memberOff": "Off",
    "memberOn": "On",
    "memberPasskey": "Passkey",
    "memberPasskeyHint": "Signs in with a passkey, which meets the policy. With the password alone, the setup comes first.",
    "memberPending": "To set up",
    "memberPendingHint": "Signs in with a password and has no second factor: they will be asked to set it up before going on",
    "memberSocialOnly": "Not needed",
    "memberSocialOnlyHint": "Signs in only with Google or Microsoft, whose own security applies",
    "methodApp": "Authenticator app",
    "methodAppSummary": "A code that changes every 30 seconds, from Google Authenticator, Microsoft Authenticator, 1Password or similar. Recommended.",
    "methodEmail": "Code by email",
    "methodEmailSummary": "A code sent to {email} at every sign-in with the password.",
    "newBackupCodes": "New backup codes",
    "newBackupCodesDescription": "The codes you have now stop working, and you get ten new ones.",
    "passkeyAdd": "Add a passkey",
    "passkeyAddDescription": "Confirm your password, then follow your device: it will ask for your fingerprint, your face or its PIN.",
    "passkeyAdded": "The passkey is ready: use it next time you sign in.",
    "passkeyAddNoPasswordDescription": "Follow your device: it will ask for your fingerprint, your face or its PIN.",
    "passkeyAlreadyRegistered": "This device already holds a passkey for your account.",
    "passkeyCancelled": "The device did not create the passkey: try again when you are ready.",
    "passkeyCreate": "Create the passkey",
    "passkeyCreatedAt": "Added on {date}",
    "passkeyDeviceBound": "On one device only",
    "passkeyDeviceRefused": "The device did not create the passkey. Check that it has a screen lock, a fingerprint or a PIN, then try again.",
    "passkeyFallbackName": "Passkey",
    "passkeyName": "Name",
    "passkeyNameHint": "To recognize it in the list",
    "passkeyRemove": "Remove",
    "passkeyRemoved": "The passkey was removed.",
    "passkeyRemoveDescription": "It will no longer sign you in. You can add a new one at any time.",
    "passkeyRemoveQuestion": "Remove the passkey {name}?",
    "passkeys": "Passkeys",
    "passkeysDescription": "Sign in with your fingerprint, your face or the PIN of your device: no password and no code. A passkey also meets an organization that requires two-step verification.",
    "passkeysEmpty": "No passkeys yet.",
    "passkeySynced": "Synced across your devices",
    "qrLabel": "QR code for the authenticator app",
    "requireConsequence": "Members who sign in with a password and have not set it up yet will be stopped at their next page until they do.",
    "requiredBy": "Required by {organizations}.",
    "requiredByPasskeyEnough": "Required by {organizations}: your passkey is enough, while the password alone will ask you to set it up.",
    "requireHint": "Members who sign in with a password must set it up before using the platform. Those who sign in with Google or Microsoft are not affected.",
    "requireLabel": "Require two-step verification",
    "requireOff": "Two-step verification is no longer required.",
    "requireOn": "Two-step verification is now required.",
    "requireQuestion": "Require two-step verification from the members?",
    "requireTitle": "Require two-step verification",
    "reset": "Reset two-step verification",
    "resetConfirm": "Reset",
    "resetDescription": "The authenticator app and the backup codes stop working and the user is signed out everywhere. They can sign in with the password alone and set it up again: we will tell them by email.",
    "resetQuestion": "Reset the two-step verification of {name}?",
    "scanDescription": "Open your authenticator app, add an account and scan the QR code. Then enter the 6-digit code it shows.",
    "sendAgain": "Send a new code",
    "setupAddAnotherPasskey": "Add a new passkey",
    "setupAddPasskey": "Use a passkey instead",
    "setupDescription": "{organizations} requires it for everyone who signs in with a password.",
    "setupSignInWithPasskey": "Sign in with your passkey",
    "setupTitle": "Set up two-step verification",
    "signInState": {
      "totp": "App",
      "otp": "Email",
      "passkey": "Passkey",
      "required": "To set up",
      "none": "Off"
    },
    "signInWithPasskey": "Sign in with a passkey",
    "stateNoPassword": "Not available for this account",
    "stateOff": "Off",
    "stateOnApp": "On, with an authenticator app",
    "stateOnEmail": "On, with a code by email",
    "summaryNoPassword": "You sign in with Google or Microsoft, so their own security applies. Add a password and you can protect it here too.",
    "summaryOff": "Asks for a code, besides the password, every time you sign in with email and password.",
    "summaryOnApp": "No backup codes left: generate new ones. | One backup code left. | {count} backup codes left.",
    "summaryOnEmail": "The code goes to {email}.",
    "switchToApp": "Use an authenticator app",
    "title": "Two-step verification",
    "trustDevice": "Trust this device for 30 days",
    "turnOff": "Turn off",
    "turnOffDescription": "From now on the password alone is enough to sign in. We will send you an email to confirm.",
    "turnOffRequired": "An organization you belong to requires it",
    "turnOffTitle": "Turn off two-step verification",
    "turnOn": "Turn on",
    "turnOnTitle": "Turn on two-step verification",
    "useApp": "Use the authenticator app",
    "useBackupCode": "Use a backup code",
    "verify": "Verify"
  },
  "userFiles": {
    "allAgents": "All agents",
    "chatFileCreated": "Created by the agent",
    "chatFileInChatOnly": "In its chat only",
    "chatFilesEmpty": "No files uploaded in this chat.",
    "chatFilesTitle": "Files in this chat",
    "chatFileVersion": "Edited by the agent",
    "deleteChatFile": "Delete file",
    "deleteChatFileConfirm": "The uploaded file and every version the agent wrote of it are deleted, from the chat too. This cannot be undone.",
    "deleteCreatedFileConfirm": "The file the agent created and every version of it are deleted, from the chat too. This cannot be undone.",
    "emptyHint": "Files you upload in chat are added here automatically and become searchable by the agent.",
    "emptyTitle": "No files yet",
    "exclude": "Remove file",
    "excludeConfirm": "The agent will not be able to search it any more. It stays in the chat you uploaded it to.",
    "loading": "Loading…",
    "open": "Open file",
    "openInChat": "Open in chat",
    "subtitle": "Files you uploaded in chat, available to the agent.",
    "title": "My files",
    "untitled": "Untitled file",
    "uploadedAt": "Uploaded"
  },
  "validation": {
    "duplicateHeader": "Two headers have the same name",
    "duplicateSecretParameter": "Two secret parameters have the same name",
    "invalidPhoneNumber": "The number entered is incorrect",
    "invalidSlug": "The slug can contain only lowercase letters, numbers and hyphens, and cannot start or end with a hyphen",
    "invalidToolName": "Name must be snake_case or kebab-case (lowercase letters, numbers, underscores, and hyphens)",
    "passwordMismatch": "Passwords do not match"
  },
  "voiceEagerness": {
    "eager": "Eager",
    "normal": "Normal",
    "patient": "Patient"
  },
  "weather": {
    "airQuality": "Air quality",
    "aqiFair": "Fair",
    "aqiGood": "Good",
    "aqiHazardous": "Hazardous",
    "aqiModerate": "Moderate",
    "aqiPoor": "Poor",
    "aqiVeryPoor": "Very poor",
    "dailyForecast": "Daily forecast",
    "feelsLike": "Feels like",
    "today": "Today",
    "unavailable": "The weather forecast is not available."
  },
  "unsubscribe": {
    "title": "Unsubscribe from these emails",
    "message": "Stop getting “{group}” notifications by email. The ones in the app do not change.",
    "action": "Unsubscribe",
    "doneTitle": "Done",
    "doneMessage": "You will no longer get “{group}” notifications by email. You can turn them back on from your profile at any time.",
    "invalidTitle": "Link not valid",
    "invalidMessage": "This link no longer works. You can turn the emails off from your profile, in the Notifications section.",
    "openSettings": "Open notification settings"
  },
  "reasoningOption": {
    "level": {
      "auto": "Automatic",
      "concise": "Concise",
      "detailed": "Detailed",
      "none": "None",
      "minimal": "Minimal",
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "xhigh": "Extra high",
      "max": "Maximum"
    },
    "anthropicType": {
      "adaptive": "Adaptive",
      "enabled": "With a token budget (legacy)",
      "disabled": "Off"
    },
    "anthropicDisplay": {
      "summarized": "Summarized",
      "omitted": "Hidden"
    }
  },
  "teamsAppType": {
    "SingleTenant": "Single tenant",
    "MultiTenant": "Multi-tenant"
  },
  "conversationSummary": {
    "intent": "Intent",
    "topicsCovered": "Topics covered",
    "keyFacts": "Key facts",
    "openQuestions": "Open questions"
  }
}
